import React from 'react';
import Table from './table';
import Button from './button'
import { debounce } from 'lodash';
import Refer from './refer';
import { getPredicateValue, getRoundValue, getMultiplication, proxy } from '../../helpers/util'
import SvgIcon from 'SvgIcon';
import * as format from '../../../common/helpers/formatDate';

// import { getPredicateValue, getRoundValue, getMultiplication, proxy } from '@mdf/cube/lib/helpers/util'
// import SvgIcon from '@mdf/metaui-web/lib/components/common/SvgIcon';

//FLH 2D OK 不必再处理 参照存货时，可以录入已经存在的存货，只要按照一维表的不重复就行。group + rowItem + colItem重复的删除
//FLH 2D OK 新增存货和新增行时，不自动找一个列赋值。而是处于待确认状态。
//FLH 2D OK 二维表新增的行：交叉点录入值后，优先找待匹配行。如果交叉点值全清空了，则自动删除对应一维表的行
//FLH 2D OK 新增一维表行时，可能因为业务校验导致增行失败，则需要单独处理后面逻辑
//FLH 2D OK 小计 合计 列小计
//FLH 2D Move 2D Table To YXYWeb
export default class table2D extends React.Component {
  constructor(props) {
    super(props);
    // 分组项:group.Fields
    // 维度项-行维度:rowItem
    // 维度项-列维度:colItem
    // 交叉点:crossItem
    // 指标项:measureItem
    try {
      let self = this;
      this.useTestData = false;
      this.bInitHasErr = false;
      this.needLog = false;
      this.table1DDataLoaded = false;
      this.totalSum = {};
      this.needformatColsInfo;//需要格式化的字段。目前只支持日期。
      this.show2DInBegin = props.show2D;//打开界面时先进入一维表还是二维表
      this.show2D = props.show2D;//当前显示界面是一维表还是二维表

      this.hide2DSum = false;//是否隐藏汇总信息（列合计，行小计，行合计）
      this.show2DRowNo = true;//是否显示行号
      let hasBillConfig = true;//是否有单据配置信息,如果有单据配置信息需要调用 /report/getTotalSetting 获取
      this.bMustShowCrossTitle = false;//只有一个交叉点时是否显示交叉点字段的栏目Caption
      this.rowItemDisabledWithValue = true;//交叉点有数值则行标题不可编辑
      let config2D = props.config2D && JSON.parse(props.config2D);
      if (config2D) {
        if (config2D.hide2DSum === true || config2D.hide2DSum === "true") {
          this.hide2DSum = true;
        }
        if (config2D.show2DRowNo === false || config2D.show2DRowNo === "false") {
          this.show2DRowNo = false;
        }
        if (config2D.hasBillConfig === false || config2D.hasBillConfig === "false") {
          hasBillConfig = false;
        }
        if (config2D.bMustShowCrossTitle === true || config2D.bMustShowCrossTitle === "true") {
          this.bMustShowCrossTitle = true;
        }
        if (config2D.rowItemDisabledWithValue === false || config2D.rowItemDisabledWithValue === "false") {
          this.rowItemDisabledWithValue = false;
        }
      }
      this.group = {
        fields: {},
        fieldsData: [],
        selectedEle: undefined
      }
      this.addGroupInfo = {
        addGroupIsRunning: false,
        addGroupInsertIndex_T1D: -1,

      };
      this.addRowInfo = {
        addRowIsRunning: false,
      };
      this.config = {};
      this.table1D = {};
      this.table2D = {};
      this.billConfig = {
        hasBillConfig: hasBillConfig,
        billConfigIsLoad: false,
        items: []
      };
      this.addRow = this.addRow.bind(this)
      this.props.viewModel.on('table2DAddRowClick',debounce(self.addRow, 300));
      this.table1D.gridModel = this.props.gridModel || this.props.viewModel.getGridModel();

      this.setTable1DListener();
      // this.setTable1DInfo();
      let params = props.viewModel.getParams();
      this.table1D.billNo = params && params.billNo;
      this.table1D.parentModel = this.table1D.gridModel && this.table1D.gridModel.getParent();

      this.state = {
        visible: true,
        focusedGroupKey: "",
        focusedGroupKeyIn: false
      };
      this.setGroupFields_Interface();

      if (this.show2DInBegin) {
        if (this.table1D.parentModel.getCache("dataLoaded") == true) {
          //物料档案中使用二维表的方式，是先打开界面后，选择物料模板（含SKU）时才渲染二维表界面。
          //这时viewmodel已经loaddata结束了。所以加了dataLoaded这个标记
          self.table1DDataLoaded = true;
          if (self.initCheck() == false) {
            self.doClose();
          }
          self.setGroupDataAndChooseGroup();
        }
        else
          this.table1D.parentModel.on('afterLoadData', function () {
            // if (self.table1DDataLoaded == false) {
            self.table1DDataLoaded = true;
            if (self.initCheck() == false) {
              self.doClose();
            }
            self.setGroupDataAndChooseGroup();
            // }
          });
      }
      else {
        //正常表格使用二维表不会加载如下代码。但物料档案加载比较特殊，选择某个模板后才加载二维表。这时一维表已经afterLoadData
        // self.setTable1DGroupReferModel();
        // self.setGroupFieldsData();
        // if (self.initCheck() == false) {
        //   self.doClose();
        // }
        // self.setGroupDataAndChooseGroup();
      }
      if (this.billConfig.hasBillConfig === true) {
        this.getBillConfig_Interface();
      }
    }
    catch (e) {
      this.LogRedInfo("初始化出错。");
      console.error(e);
      this.doClose();
    }
  }

  setActionsState(bReadOnly) {
    let self = this;
    if (self.table2D.gridModel) {
      if (bReadOnly === undefined)
        bReadOnly = self.table2D.gridModel.getReadOnly();
      let actionsStates = [];
      let rows = self.table2D.gridModel.getRows();
      rows.forEach((row) => {
        const actionState = {};
        actionState.btnDeleteRow = { visible: !bReadOnly };
        actionsStates.push(actionState);
      })
      self.table2D.gridModel.setActionsState(actionsStates);
    }
  }

  setTable1DListener() {
    let self = this;
    self.T1D_Listener = {};
    self.T1D_Listener["setReadOnly"] = (params) => {
      let value = !!params;
      self.table2D.gridModel && self.table2D.gridModel.setReadOnly(value);
      self.setActionsState(value);
    };

    self.T1D_Listener["setT2DRowState"] = (params) => {
      let t1DRowIndex = params.t1DRowIndex;
      let name = params.name;
      let value = params.value;
      let row = (t1DRowIndex >= 0) && self.table1D.gridModel.getRow(t1DRowIndex);
      let t2DRowKey = row && row.t2DInfoIn1DRow && row.t2DInfoIn1DRow.t2DRowKey;
      let t2DRowIndex = t2DRowKey && self.getMatchedTable2DRowByRowKey(t2DRowKey);
      if ((t2DRowIndex >= 0) && name && value !== undefined) {
        self.table2D.gridModel.setRowState(t2DRowIndex, name, value);
      }
    };

    self.table1D.gridModel.addListener(self.T1D_Listener)
  }

  isExistInGroup(newCode) {
    let arr = _.filter(this.group.fieldsData, function (o) { return o.code == newCode })
    if (arr.length > 0) {
      return true;
    }
    else {
      return false;
    }
  }

  setTable2DEditRowModel(t2DColType, data) {
    this.LogInfo("setTable2DEditRowModel t2DColType = " + t2DColType + " data = " + JSON.stringify(data));

    if (t2DColType == "crossItem") {
      let tmp = this.table2D.gridModel.t2DInfo_Bus_Get("EditRowModel_2D");
      if (tmp) {
        this.table2D.gridModel._set_data('editRowModel', tmp);
        this.LogInfo("setTable2DEditRowModel 二维表 editRowModel修改为二维表自己的 ");
      }
      else
        this.LogRedInfoAndAlert("设置交叉点的editRowModel时，不能从为gridModel缓存中获取EditRowModel_2D");
    }
    else {
      let editRowModel = this.getTable1DEditRowModel();
      this.table2D.gridModel._set_data('editRowModel', editRowModel);
      this.LogInfo("setTable2DEditRowModel 二维表 editRowModel修改为一维表的 ");
    }
  }
  //零售要货任务-要货计划周期要求的接口，需要根据当前选择的所有一维表行来刷新二维表下面的要货明细表
  trigSelectT1DRowsEvent = (t2DColType, t2DRowKey, t2DColKey) => {
    let selectedT1DIndexs = this.getMatchedTable1DRowsByRowColKey(t2DColType, t2DRowKey, t2DColKey, true);
    if (_.isEqual(selectedT1DIndexs, this.selectedT1DIndexs) == false) {
      this.selectedT1DIndexs = selectedT1DIndexs;
      let args = { t1DIndexs: selectedT1DIndexs };
      let gridModel = this.table1D.gridModel;
      gridModel && gridModel.execute("Table2DEvent_SelectT1DRows", args);
    }
  }

  table2DRowColChange = (data) => {
    this.LogInfo_All();
    this.LogInfo(" table2DRowColChange data = " + JSON.stringify(data));
    let self = this;
    let rowIndex = data.value.rowIndex;
    let row = this.table2D.gridModel.getRow(rowIndex);
    let column = data.value.column;
    let t2DRowKey = row.t2DRowKey;
    let t2DColKey = column.t2DColKey;
    let t2DColType = column.t2DColType;
    // let t2DInfo_MultiCol = column.t2DInfo_MultiCol;
    // t2DColType == "" ||
    this.trigSelectT1DRowsEvent(t2DColType, t2DRowKey, t2DColKey);
    if (t2DColType == "rowItem" && this.rowItemDisabledWithValue == true) {
      //检查是否二维表行的交叉点有数值。如果有数值则不能更改
      let columns = this.table2D.gridModel.getColumns();
      let bHasValue = false;
      Object.values(columns).forEach((col) => {
        if (col.t2DColType == "crossItem") {
          let value = row[col.fieldName];
          if (self.isNoValue(value) == false) {
            bHasValue = true;
          }
        }
      })
      if (bHasValue == true) {
        return false;//有值后就禁止编辑
      }
    }
    if (t2DColType == "rowItem" || t2DColType == "measureItem") {
      let indexs = this.getMatchedTable1DRowsByRowColKey(t2DColType, t2DRowKey, t2DColKey, true);
      if (indexs.length > 0) {
        let preIndex = this.table1D.gridModel.getFocusedRowIndex()
        if (preIndex != indexs[0]) {
          this.LogInfo(" table2DRowColChange 一维表当前index = " + preIndex + " 跳转到Index = " + indexs[0]);
          this.table1D.gridModel.setFocusedRowIndex(indexs[0]);
        }
      }
    }
    else if (t2DColType == "crossItem") {
    }
    else if (t2DColType == "crossItemSum") {
    }
    else {
      self.LogRedInfo("二维表行列变化异常，没有列类型t2DColType。data= " + JSON.stringify(data));
    }
    this.setTable2DEditRowModel(t2DColType, data);
  }

  addGroup_Table1D_GroupReferModalOkClick = (data) => {
    let self = this;
    if (self.show2D == true && self.addGroupInfo && self.addGroupInfo.addGroupIsRunning) {
      this.LogInfo(" addGroup_Table1D_GroupReferModalOkClick data = " + JSON.stringify(data));
      if (data && data.length > 0) {
        let repeatIndex = [];
        let newAddCode = [];
        for (let i = self.addGroupInfo.addGroupInsertIndex_T1D; i < self.table1D.gridModel.getRowsCount(); i++) {
          let row = self.table1D.gridModel.getRow(i);
          let code = row[self.group.fields.codeField];
          if (newAddCode.indexOf(code) >= 0 || self.isExistInGroup(code)) {
            repeatIndex.push(i);
          }
          else {
            newAddCode.push(code);
          }
        }
        if (repeatIndex.length > 0) {
          self.table1D.gridModel.deleteRows(repeatIndex);
        }
        if (self.table1D.gridModel.getRowsCount() == self.addGroupInfo.addGroupInsertIndex_T1D) {
          cb.utils.alert("录入信息重复，请检查。")
          self.addGroup_DoReferCancel();
        }
        else {

          let newIndexs = [];
          let groupObj;
          for (let i = self.addGroupInfo.addGroupInsertIndex_T1D; i < self.table1D.gridModel.getRowsCount(); i++) {
            let row = self.table1D.gridModel.getRow(i);
            newIndexs.push(i);
            let id = row[this.group.fields.idField];
            let code = row[self.group.fields.codeField];
            let name = row[self.group.fields.nameField];
            if (_.find(self.group.fieldsData, function (o) { return o.code == code }) == undefined) {
              groupObj = {
                id,
                code,
                name,
                caption: name + "(" + code + ")",
                groupKey: self.getRandomKey("Group_")
              };
              self.group.fieldsData.push(groupObj);
            }
          }
          // self.FixTable1DRowsColItemValue(newIndexs);
          self.groupSelected(groupObj);
          self.addGroupInfo.addGroupIsRunning = false;
        }
      }
      else {
        self.addGroup_DoReferCancel();
      }
    }
    else {
      self.LogRedInfo("增行异常。self.addGroupInfo = " + JSON.stringify(self.addGroupInfo));
    }
  }

  addGroup_Table1D_GroupReferModalCloseClick = (data) => {
    if (this.show2D == true)
      this.addGroup_DoReferCancel();
  }

  addGroup_DoReferCancel() {
    if (this.addGroupInfo && this.addGroupInfo.addGroupIsRunning == true) {
      this.table1D.gridModel.deleteRows(this.addGroupInfo.addGroupInsertIndex_T1D);
      this.addGroupInfo.addGroupIsRunning = false;
    }
  }

  addGroup_Table1D_GroupReferModal_BeforeBrowse = () => {
    // try {
    if (this.show2D == true) {
      this.addGroupInfo.addGroupIsRunning = true;
      this.table1D.gridModel.appendRow();
      let index = this.table1D.gridModel.getRowsCount() - 1;
      this.addGroupInfo.addGroupInsertIndex_T1D = index;
      this.table1D.gridModel.setFocusedRowIndex(index);
    }
    // }
    // catch (e) {
    //   this.addGroupInfo.addGroupIsRunning = false;
    //   throw e;
    // }
  }

  addGroup_Table1D_GroupReferModal_AfterBrowse = () => {
    let referViewModel = this.table1D.groupReferModel.getCache("vm");
    if (this.show2D == true && referViewModel) {
      referViewModel.un("afterOkClick", this.addGroup_Table1D_GroupReferModalOkClick);
      referViewModel.on("afterOkClick", this.addGroup_Table1D_GroupReferModalOkClick);
      referViewModel.un("referModalClose", this.addGroup_Table1D_GroupReferModalCloseClick);
      referViewModel.on("referModalClose", this.addGroup_Table1D_GroupReferModalCloseClick);
    }
  }

  getTable1DNewRowPositionByInputCrossValue(codeValue) {
    let self = this;
    let rows = this.table1D.gridModel.getRows();
    if (self.group.hasGroup) {
      codeValue = codeValue || this.group.selectedEle.code;
      let index = _.findLastIndex(rows, function (row) { return row[self.group.fields.codeField] == codeValue });
      if (index >= 0)
        return index + 1;
      else
        return rows.length;
    }
    else {
      return rows.length;
    }
  }

  getTable1DLastRowPositionByGroupCode(codeValue) {
    let self = this;
    let rows = this.table1D.gridModel.getRows();
    if (this.group.hasGroup) {
      codeValue = codeValue || (this.group.selectedEle && this.group.selectedEle.code) || "";
      let index = _.findLastIndex(rows, function (row) { return row[self.group.fields.codeField] == codeValue });
      if (index >= 0)
        return index + 1;
      else
        return rows.length;
    }
    else
      return rows.length;
  }
  rowHasItemDataValue = (row) => {
    let rowFields = this.config.rowItemData.fieldNames;
    let bHasValue = false;
    rowFields.forEach((field) => {
      if (this.isNoValue(row[field]) == false) {
        bHasValue = true;
      }
    })
    return bHasValue;
  }
  checkCanAddRow() {
    if (this.group.hasGroup == true && this.isNoValue(this.group.fieldsData)) {
      cb.utils.alert("请选择分组项。");
      return false;
    } else {
      let rowFields = this.config.rowItemData.fieldNames;
      let rows = this.table2D.gridModel.getRows();
      // 只要有一个空值
      let hasEmptyRow  = rows.some((row) =>rowFields.every(field=>{
        // 空值 或者 默认值
        let _column = this.table2D.columns[field];
        return this.isNoValue(row[field]) || (_column && _column.cDefaultValue && row[field] == _column.cDefaultValue)
      }))
      if (hasEmptyRow) {
        cb.utils.alert("存在空白行标题的行或行标题未赋新值");
        return false;
      }
    }
    return true;
  }

  addRow() {
    this.LogInfo("addRow begin 1")
    let self = this;
    if (self.checkCanAddRow()) {
      this.LogInfo("addRow begin 2")
      self.addRowInfo.addRowIsRunning = true;
      let table1DIndex = self.getTable1DLastRowPositionByGroupCode();
      if (table1DIndex == undefined) {
        table1DIndex = self.table1D.gridModel.getRowsCount();
      }
      let rowObj1 = self.getTable1DDefaultRowObj();
      let insertData = self.table1D.gridModel.insertRow(table1DIndex, rowObj1);
      if (insertData && insertData.row) {
        this.LogInfo("addRow begin 3")
        self.groupSelected(self.group.selectedEle);
        self.addRowInfo.addRowIsRunning = false;
      }
    }
  }

  delGroup(ele) {
    let self = this;
    cb.utils.confirm("确定删除分组么", function () {
      ele = ele || self.group.selectedEle;
      self.doDelGroup(ele);
    });
  }

  delRow(index) {
    let self = this;
    if (self.table2D.gridModel.getRowsCount() > 1) {
      cb.utils.confirm("确定删除当前行么", function () {
        if (index === undefined) {
          index = self.table2D.gridModel.getFocusedRowIndex();
        }
        self.doDelRow(index);
      });
    }else {
      cb.utils.alert("至少保留一行数据。");
    }
  }

  doDelRow(index) {
    let self = this;
    if (index >= 0) {
      let row = self.table2D.gridModel.getRow(index);
      self.table2D.gridModel.deleteRows(index);
      let indexs = self.getMatchedTable1DRowsByRowColKey("", row.t2DRowKey, "", true)
      self.table1D.gridModel.deleteRows(indexs);
    }else {
      cb.utils.alert("请选择行");
    }
  }

  doDelGroup(groupEle) {
    let groupKey = groupEle.groupKey;
    let indexs = this.getMatchedTable1DRowsByGroupEle(groupEle)
    this.table1D.gridModel.deleteRows(indexs);
    _.remove(this.group.fieldsData, function (o) { return o.groupKey == groupKey; });
    if (this.group.fieldsData.length > 0) {
      this.groupSelected(this.group.fieldsData[0]);
    }else {
      this.group.selectedEle = undefined;
      this.table2D.gridModel.clear();
    }
    this.forceUpdate();
  }
  formatTable1DRow(row, obj) {
    if (this.formatColsInfo) {
      Object.keys(this.formatColsInfo).forEach((fieldName) => {
        let value = row[fieldName];
        if (value)
          obj[fieldName] = format.dateFormat(new Date(value), this.formatColsInfo[fieldName]);
      })
    }
    return obj;
  }

  initTable1DRows() {
    let gridModel = this.table1D.gridModel;
    let rows = gridModel.getRows();
    rows.forEach((row, index) => {
      let obj = {};
      if (this.group.hasGroup == true) {
        let codeValue = this.group.selectedEle.code;
        let codeField = this.group.fields.codeField;
        obj = { t2DInfoIn1DRow: { isShow: row[codeField] == codeValue, t2DRowKey: "", t2DColKey: "" } };
      } else {
        obj = { t2DInfoIn1DRow: { isShow: true, t2DRowKey: "", t2DColKey: "" } };
      }
      obj = this.formatTable1DRow(row, obj);
      gridModel.updateRowNoEvent(index, obj);
    })
  }

  initCheck() {
    let gridModel = this.table1D.gridModel;
    if (!this.table1D.billNo) {
      this.LogRedInfoAndAlert("初始化条件中没有billNo。");
      return false;
    }
    if (!gridModel) {
      this.LogRedInfoAndAlert("初始化条件中没有Model。");
      return false;
    }
    if (
      this.group.hasGroup &&
      (gridModel.hasColumn(this.group.fields.idField) == false ||
        gridModel.hasColumn(this.group.fields.codeField) == false ||
        gridModel.hasColumn(this.group.fields.nameField) == false)
    ) {
      this.LogRedInfoAndAlert("配置文件中分组项字段[" + this.group.fields.idField + " " + this.group.fields.codeField + " " + this.group.fields.nameField + "]不存在于源表栏目中，请检查。");
      return false;
    }
    return true;
  }

  //显示选定的Group
  groupSelected(ele, bFirst) {
    this.table2D.gridModel && this.table2D.gridModel.doPropertyChange('resetCellStatus');
    let bOK = this.checkGroupAndSetConfig(ele, bFirst);
    if (bOK) {
      this.group.selectedEle = ele
      // this.setReferFieldsModel();
      this.refreshTable2DColumnsAndDataSource();
      this.setGridModel();
      this.forceUpdate();
      let indexs = this.getMatchedTable1DRowsByIsShow();
      if (indexs.length > 0) {
        this.table1D.gridModel.setFocusedRowIndex(indexs[0]);
      }
      this.calcRowCrossItemSum(true);
      this.calcTotalSum(true);
    }
  }

  //根据当前物料重新刷新栏目数据和数据
  refreshTable2DColumnsAndDataSource() {
    this.initTable2DColumns();
    this.refreshTable2DDataSource();
  }

  //根据当前物料重新初始化二维表的DataSource，并与一维表的行关联
  refreshTable2DDataSource() {

    let self = this;
    let config = this.config;
    let rowItemData = config.rowItemData;
    // let gridModel = this.table1D.gridModel;
    let columns2 = this.table2D.columns;
    let dataSource = [];

    this.initTable1DRows();

    if (_.isEmpty(rowItemData) == false) {
      let crossCols = _.filter(columns2, function (col) { return col.t2DColType == "crossItem" })
      rowItemData.fieldValues && rowItemData.fieldValues.forEach((row) => {
        let t2DRowKey = this.getRandomKey("Row_");
        // let tmpOriginRows = _.cloneDeep(originRows);
        let obj = this.getTable2DDefaultRow();
        obj.t2DRowKey = t2DRowKey;
        let rowItemMatchInfo = {};
        row.forEach((value, index) => {
          obj[rowItemData.fieldNames[index]] = value;
          rowItemMatchInfo[rowItemData.fieldNames[index]] = value;
          if (value !== "") {
            //如果是像物料档案那种固定行标题（二维表中不能增行）的,则需要在二维表上赋上行标题字段的key值等信息
            obj = self.setRowModelValue(obj, rowItemData.fieldNames[index], value);
          }
        })
        let rowsTmp = self.table1D.gridModel.getRows();
        let indexArr1 = self.getMatchedTable1DRowByRowColValue(rowsTmp, rowItemMatchInfo);
        indexArr1.forEach((index) => {
          self.table1D.gridModel.updateRowNoEvent(index, { t2DInfoIn1DRow: { t2DRowKey: t2DRowKey } })
        })

        crossCols.forEach((col) => {
          let t2DInfo_MultiCol = col.t2DInfo_MultiCol;
          let rows = self.table1D.gridModel.getRows();
          let indexArr2 = self.getMatchedTable1DRowByRowColValue(rows, rowItemMatchInfo, t2DInfo_MultiCol.valueArr, t2DRowKey, col.t2DColKey);
          if (indexArr2.length > 0) {
            let index = indexArr2[0];
            obj[col.fieldName] = rows[index][t2DInfo_MultiCol.originField];
            self.table1D.gridModel.updateRowNoEvent(index, { t2DInfoIn1DRow: { t2DRowKey: t2DRowKey, t2DColKey: col.t2DColKey } })
          }
        })
        dataSource.push(obj);
        // originDataSource.push(tmpOriginRows);
        // originDataSource = _.concat(originDataSource, tmpOriginRows);
      })
    }
    let checkRows = this.table1D.gridModel.getRows();
    let checkArrEmpty = _.filter(checkRows, function (row) { return row.t2DInfoIn1DRow && row.t2DInfoIn1DRow.isShow == true && row.t2DInfoIn1DRow.t2DRowKey == "" })
    if (checkArrEmpty.length > 0) {
      this.LogRedInfo("一维表存在行键值为空的行。 空行 = " + JSON.stringify(checkArrEmpty) + " 一维表所有行 = " + JSON.stringify(checkRows));
    }
    let checkArr = _.filter(checkRows, function (row) { return row.t2DInfoIn1DRow && row.t2DInfoIn1DRow.isShow == true && (row.t2DInfoIn1DRow.t2DRowKey != "" && row.t2DInfoIn1DRow.t2DColKey == "") })
    if (checkArr.length > 0) {
      this.LogRedInfo("一维表存在没有匹配到二维表单元格的行。 未匹配行 = " + JSON.stringify(checkArr) + " 一维表所有行 = " + JSON.stringify(checkRows));
    }
    dataSource = this.getMeasureValues(dataSource);
    this.table2D.dataSource = dataSource;

  }

  setGridModel() {
    let self = this;
    this.unSetTrigger_2D();
    let focusedRowIndex = -1;
    if (this.table2D.gridModel) {
      focusedRowIndex = this.table2D.gridModel.getFocusedRowIndex();
    }
    let readOnly = false;
    if (this.table1D.gridModel) {
      readOnly = this.table1D.gridModel.getReadOnly();
    }
    this.table2D.gridModel = new cb.models.GridModel({
      columns: this.table2D.columns,
      independent: true,//此处independent和下面的setParent逻辑有冲突的地儿，如果后面二维表支持孙表，则此处需要修改为false
      readOnly: readOnly,
      showRowNo: self.show2DRowNo,
      pagination: false,
      dataSourceMode: 'local',
      isDirty: false,
      showCheckBox: false,
      showColumnSetting: false,
      showAggregates: false
    });
    if (this.table1D.parentModel) {
      this.table2D.gridModel.setParent(this.table1D.parentModel);
    }
    this.table2D.gridModel.setCache("T2DKey_Bus", this.table1D.gridModel.getCache("T2DKey_Bus"));
    this.table2D.gridModel.setCache("T2D_TableNum", "2D");
    this.table2D.gridModel.t2DInfo_Bus_Set("Table2DGridModel", this.table2D.gridModel);
    this.table2D.gridModel.on('afterSetEditRowModel', function () {
      let tmp = self.table2D.gridModel.getEditRowModel();
      tmp.setReadOnly(false);
      tmp.setDisabled(false);
      self.table2D.gridModel.t2DInfo_Bus_Set("EditRowModel_2D", tmp);
    })
    this.table2D.gridModel.setColumns(this.table2D.columns);
    this.table2D.gridModel.setDataSource(this.table2D.dataSource);
    if (focusedRowIndex >= 0) {
      // this.table2D.gridModel.setFocusedRowIndex(focusedRowIndex);
    }
    this.setTrigger_2D();

    // if (!this.table2D.gridModel) {
    // this.table2D.gridModel = new cb.models.GridModel({
    // columns: this.table2D.columns,
    // independent: true,
    // readOnly: false,
    // showRowNo: false,
    // pagination: false,
    // dataSourceMode: 'local',
    // isDirty: false,
    // showCheckBox: false,
    // showColumnSetting: false,
    // showAggregates: false
    // });
    // this.table2D.gridModel.setParent(this.table1D.parentModel);
    // }
    // else {
    // this.unSetTrigger();
    // }
    // this.table2D.gridModel.setColumns(this.table2D.columns);
    // this.table2D.gridModel.clear();
    // this.table2D.gridModel.setDataSource(this.table2D.dataSource);
    // this.setTrigger();

  }

  setTrigger_1D() {
    let self = this;
    // self.unSetTrigger();
    self.table1D.gridModel && self.table1D.gridModel.on('afterCellValueChange', self.afterTable1DCellValueChange);
    // self.table1D.gridModel && self.table1D.gridModel.on('Table2DEvent_SetCellBlur', self.Table2DEvent_SetCellBlur);
    self.table1D.gridModel && self.table1D.gridModel.on('Table2DEvent_RefreshConfig', self.Table2DEvent_RefreshConfig);
    self.table1D.gridModel && self.table1D.gridModel.on('Table2DEvent_SetStates', self.Table2DEvent_SetStates);
    self.table1D.gridModel && self.table1D.gridModel.on('Table2DEvent_SetGridStates', self.Table2DEvent_SetGridStates);
    self.table1D.gridModel && self.table1D.gridModel.on('Table2DEvent_GetColumnsAndData', self.Table2DEvent_GetColumnsAndData);
    // self.table1D.gridModel && self.table1D.gridModel.on('afterUpdateRow', self.addGroup_Table1D_AfterUpdateRow);

  }

  unSetTrigger_1D() {
    let self = this;
    self.table1D.gridModel && self.table1D.gridModel.un('afterCellValueChange', self.afterTable1DCellValueChange);
    // self.table1D.gridModel && self.table1D.gridModel.un('Table2DEvent_SetCellBlur', self.Table2DEvent_SetCellBlur);
    self.table1D.gridModel && self.table1D.gridModel.un('Table2DEvent_RefreshConfig', self.Table2DEvent_RefreshConfig);
    self.table1D.gridModel && self.table1D.gridModel.un('Table2DEvent_SetStates', self.Table2DEvent_SetStates);
    self.table1D.gridModel && self.table1D.gridModel.un('Table2DEvent_SetGridStates', self.Table2DEvent_SetGridStates);
    self.table1D.gridModel && self.table1D.gridModel.un('Table2DEvent_GetColumnsAndData', self.Table2DEvent_GetColumnsAndData);
    // self.table1D.gridModel && self.table1D.gridModel.un('afterUpdateRow', self.addGroup_Table1D_AfterUpdateRow);
  }

  setTrigger_2D() {

    //beforeTable2DCellValueChange 处理通过编辑界面录入的值，通知一维表改变
    //afterTable1DCellValueChange 目前处理因为界面录入导致后台计算，引起的一维表的值改变，来同步二维表
    let self = this;
    // self.table2D.gridModel && self.table2D.gridModel.on('beforeCellValueChange', self.beforeCellValueChange);
    self.table2D.gridModel && self.table2D.gridModel.on('Table2DEvent_BeforeCellValueChange', self.Table2DEvent_BeforeCellValueChange);
    self.table2D.gridModel && self.table2D.gridModel.on('rowColChange', self.table2DRowColChange);
    self.table2D.gridModel && self.table2D.gridModel.on('Table2DEvent_CheckCanMultiRefer', self.Table2DEvent_CheckCanMultiRefer);
    self.table2D.gridModel && self.table2D.gridModel.on('afterCalcSubTotal', self.Table2DEvent_AfterCalcSubTotal);


  }

  unSetTrigger_2D() {
    let self = this;
    // self.table2D.gridModel && self.table2D.gridModel.un('beforeCellValueChange', self.beforeCellValueChange);
    self.table2D.gridModel && self.table2D.gridModel.un('Table2DEvent_BeforeCellValueChange', self.Table2DEvent_BeforeCellValueChange);
    self.table2D.gridModel && self.table2D.gridModel.un('rowColChange', self.table2DRowColChange);
    self.table2D.gridModel && self.table2D.gridModel.un('Table2DEvent_CheckCanMultiRefer', self.Table2DEvent_CheckCanMultiRefer);
    self.table2D.gridModel && self.table2D.gridModel.un('afterCalcSubTotal', self.Table2DEvent_AfterCalcSubTotal);
  }

  getMatchedTable1DRowsByIsShow() {
    let arr = [];
    let rows = this.table1D.gridModel.getRows();
    rows.forEach((ele, index) => {
      if (ele.t2DInfoIn1DRow && ele.t2DInfoIn1DRow.isShow == true) {
        arr.push(index);
      }
    })
    return arr;
  }

  getMatchedTable1DRowsByGroupEle(groupEle) {

    let arr = [];
    let rows = this.table1D.gridModel.getRows();
    let codeField = this.group.fields.codeField;
    rows.forEach((ele, index) => {
      if (ele[codeField] == groupEle.code) {
        arr.push(index);
      }
    })
    return arr;
  }

  getMatchedTable1DRowsByRowColKey(t2DColType, t2DRowKey, t2DColKey, bReturnIndex) {
    let arrIndex = [];
    let arrValue = [];
    let rows = this.table1D.gridModel.getRows();
    rows.forEach((ele, index) => {
      let t2DInfoIn1DRow = ele.t2DInfoIn1DRow;
      if (t2DInfoIn1DRow && t2DInfoIn1DRow.isShow) {
        if (t2DColType == "rowItem" || t2DColType == "measureItem") {
          if (t2DInfoIn1DRow.t2DRowKey == t2DRowKey) {
            arrIndex.push(index);
            arrValue.push(ele);
          }
        }
        else if (t2DColType == "crossItem") {
          if (t2DInfoIn1DRow.t2DRowKey == t2DRowKey && t2DInfoIn1DRow.t2DColKey == t2DColKey) {
            arrIndex.push(index);
            arrValue.push(ele);
          }
        }
        else {
          if (
            (!t2DRowKey || t2DInfoIn1DRow.t2DRowKey == t2DRowKey)
            && (!t2DColKey || t2DInfoIn1DRow.t2DColKey == t2DColKey)
          ) {
            arrIndex.push(index);
            arrValue.push(ele);
          }
        }
      }
    })

    if (t2DColType == "crossItem" && arrIndex.length > 1) {
      this.LogRedInfo("在一维表中发现多行符合当前交叉点行列键值的数据 t2DRowKey = " + t2DRowKey + " t2DColKey = " + t2DColKey + " 行列= " + JSON.stringify(arrIndex));
    }
    if (bReturnIndex)
      return arrIndex;
    else
      return arrValue;
  }

  getTable1DChangedRows(t2DColType, indexs, originField, newValue) {
    //一维表中数值的确改变了才触发
    // let isChanged = false;
    let rows = this.table1D.gridModel.getRows();
    let arr = [];
    indexs.forEach((index) => {
      let row = rows[index];
      if (row[originField] != newValue) {
        arr.push(index);
        // row[originField] = newValue;
      }
    })
    return arr;
  }

  //
  //使用新的逻辑，全面复制二维表行，然后去除不复制部分
  insertTable1DRowForInputCrossValue(rowInfo, colInfo, data) {
    // let self = this;
    let t2DInfo_MultiCol = colInfo.t2DInfo_MultiCol;
    // let rowItemData = this.config.rowItemData;
    // let colItemData = this.config.colItemData;
    let obj = _.cloneDeep(rowInfo);
    this.config.insertRowConfig.unCopyFieldNames.forEach((fieldName) => {
      delete obj[fieldName];
    })

    let columns = this.table2D.gridModel.getColumns();
    Object.values(columns).forEach((col) => {
      if (col.t2DColType == "crossItem" || col.t2DColType == "crossItemSum") {
        delete obj[col.fieldName];
      }
    })

    // if (false) {
    //   colItemData.fieldNames.forEach(fieldName => {
    //     obj[fieldName] = t2DInfo_MultiCol.valueArr[fieldName];
    //   });
    // }
    // else {
    Object.keys(t2DInfo_MultiCol.valueArr).forEach((fieldName) => {
      obj[fieldName] = t2DInfo_MultiCol.valueArr[fieldName];
    })
    // }
    obj.t2DInfoIn1DRow = { isShow: true, t2DRowKey: rowInfo.t2DRowKey, t2DColKey: colInfo.t2DColKey };
    // obj = this.getTable1DDefaultRowObj(obj);
    // if (this.isNoValue(data) == false) {
    //   let originField = t2DInfo_MultiCol ? t2DInfo_MultiCol.originField : colInfo.fieldName;
    //   obj[originField] = data.value;
    // }
    let index = this.getTable1DNewRowPositionByInputCrossValue();
    let insertData = this.table1D.gridModel.insertRow(index, obj);
    if (insertData && insertData.row) {
      return index;
    }
    else {
      return -1;
    }
  }
  // //处理输入交叉点导致一维表增行的逻辑
  // insertTable1DRowForInputCrossValue2(rowInfo, colInfo, data) {

  //   let self = this;
  //   let gridModel = this.table1D.gridModel;
  //   // let t2DColType = colInfo.t2DColType;
  //   let t2DInfo_MultiCol = colInfo.t2DInfo_MultiCol;

  //   let rowItemData = this.config.rowItemData;
  //   let colItemData = this.config.colItemData;
  //   let obj = {};
  //   rowItemData.fieldNames.forEach(fieldName => {
  //     // obj[fieldName] = rowInfo[fieldName];
  //     obj = self.setRowModelValue(obj, fieldName, rowInfo[fieldName], rowInfo);
  //   });

  //   // 是否应该用下面的逻辑
  //   if (true) {
  //     colItemData.fieldNames.forEach(fieldName => {
  //       obj[fieldName] = t2DInfo_MultiCol.valueArr[fieldName];
  //     });
  //   }
  //   else {
  //     Object.keys(t2DInfo_MultiCol.valueArr).forEach((fieldName) => {
  //       obj[fieldName] = t2DInfo_MultiCol.valueArr[fieldName];
  //     })
  //   }

  //   obj.t2DInfoIn1DRow = { isShow: true, t2DRowKey: rowInfo.t2DRowKey, t2DColKey: colInfo.t2DColKey };
  //   obj = this.getTable1DDefaultRowObj(obj);

  //   if (this.isNoValue(data) == false) {
  //     let originField = t2DInfo_MultiCol ? t2DInfo_MultiCol.originField : colInfo.fieldName;
  //     // gridModel.setCellValue(index, originField, data.value, true, false);
  //     obj[originField] = data.value;
  //   }
  //   let index = this.getTable1DNewRowPositionByInputCrossValue();
  //   let insertData = gridModel.insertRow(index, obj);
  //   if (insertData && insertData.row) {
  //     return true;
  //   }
  //   else {
  //     return false;
  //   }
  // }

  getMatchedTable2DColsByColKeyAndOriginField(t2DColKey, originField) {
    let tmp = [];
    Object.values(this.table2D.columns).forEach((col) => {
      if (col.t2DColKey == t2DColKey) {
        if (originField == "" || col.t2DInfo_MultiCol.originField == originField)
          tmp.push(col);
      }
    })
    return tmp;
  }

  getMatchedTable2DRowByRowKey(t2DRowKey) {
    let tmp = -1;
    this.table2D.gridModel.getRows().forEach((row, index) => {
      if (row.t2DRowKey == t2DRowKey)
        tmp = index;
    })
    return tmp;
  }

  checkCanChangeTable2DRowItem(data, relatedChangeObj) {
    let self = this;
    let bCheckOk = true;
    // {"rowIndex":0,"cellName":"free1","value":{"name":"L码","_id":"rowId_54"}}
    let rowIndex = data.rowIndex;
    let fieldName = data.cellName;
    let valueObj = data.value;
    let value = valueObj.name;
    let arr_CheckRepeat = [];
    let rowFields = this.config.rowItemData.fieldNames;
    let rows = this.table2D.gridModel.getRows();

    rows.forEach((row) => {
      let obj = {};
      rowFields.forEach((field) => {
        obj[field] = row[field];
      });
      arr_CheckRepeat.push(obj);
    });
    if (typeof (data.value) === 'object') {
      rowFields.forEach((field) => {
        if (data.value.hasOwnProperty(field)) {
          arr_CheckRepeat[rowIndex][field] = data.value[field];

        }
      });
    }
    else {
      arr_CheckRepeat[rowIndex][fieldName] = value;
    }
    relatedChangeObj && Object.keys(relatedChangeObj).forEach((key) => {
      if (arr_CheckRepeat[rowIndex].hasOwnProperty(key))
        arr_CheckRepeat[rowIndex][key] = relatedChangeObj[key];
    })
    arr_CheckRepeat.forEach((ele, index) => {
      Object.keys(ele).forEach((key) => {
        if (self.isNoValue(ele[key])) {
          ele[key] = "";
        }
      })
      arr_CheckRepeat[index] = JSON.stringify(ele);
    })

    arr_CheckRepeat = arr_CheckRepeat.sort();
    for (var i = 0; i < arr_CheckRepeat.length - 1; i++) {
      if (_.isEqual(arr_CheckRepeat[i], arr_CheckRepeat[i + 1]) == true) {
        this.LogRedInfoAndAlert("当前选择会导致行标题存在重复信息,请检查。");
        i = arr_CheckRepeat.length;
        // self.doClose();
        bCheckOk = false;
      }
    }
    return bCheckOk;
  }

  getUnMatchedRowIndex(t2DRowKey) {
    let rows = this.table1D.gridModel.getRows();
    let index = _.findIndex(rows, function (row) {
      let t2DInfoIn1DRow = row.t2DInfoIn1DRow;
      if (t2DInfoIn1DRow && t2DInfoIn1DRow.isShow == true && t2DInfoIn1DRow.t2DRowKey == t2DRowKey && t2DInfoIn1DRow.t2DColKey == "") {
        return true;
      }
      else {
        return false;
      }
    })
    return index;
  }


  Table2DEvent_AfterCalcSubTotal = (args) => {
    let gridModel = this.table1D.gridModel;
    gridModel.execute('Table2DEvent_AfterCalcSubTotal', args)
    // let gridModel = this.table2D.gridModel;
    // gridModel.setState({ 'subtotalData': args });
  }

  Table2DEvent_CheckCanMultiRefer = (args) => {
    let self = this;
    let { rowIndex, cellName, referArgs, rowDatas, referRows } = args;
    let rowFields = _.get(self, "config.rowItemData.fieldNames");
    let bOK = false;
    let rows = self.table2D.gridModel.getRows();
    let length = rows.length;
    let row = rows[rowIndex];
    if (
      rowFields.indexOf(cellName) >= 0 &&//如果是行维度
      rowIndex + 1 == length &&//而且最后一行
      self.rowHasItemDataValue(row) == false//而且最后一行是空白行
    ) {
      //去除重复
      let repeatArr = [];
      rows.forEach((row) => {
        let tmpValue = row[cellName];
        if (_.isEmpty(tmpValue) == false && repeatArr.indexOf(tmpValue) <= 0) {
          repeatArr.push(tmpValue);
        }
      })
      for (let i = 0; i < rowDatas.length; i++) {
        let rowData = rowDatas[i];
        let fieldValue = rowData[cellName]
        if (repeatArr.indexOf(fieldValue) < 0) {
          repeatArr.push(fieldValue);
        }
        else {
          rowDatas.splice(i, 1);
          referRows.splice(i, 1);
        }
      }
      bOK = true;
    }
    return bOK;
  }
  Table2DEvent_BeforeCellValueChange = (data) => {
    this.LogInfo("Table2DEvent_BeforeCellValueChange data = " + JSON.stringify(data));
    let self = this;
    let bChangeOK = true;
    // if (data.eventType == "refer2" || data.eventType == "cellValue") {
    //   //  检查一下参照只支持单行和非参照赋值的逻辑，除了删除已有refer字段
    //   debugger;
    // }
    if (self.show2D == true && self.addRowInfo.addRowIsRunning == false && self.addGroupInfo.addGroupIsRunning == false) {

      let gridModel = this.table1D.gridModel;
      let rowInfo = this.table2D.gridModel.getRow(data.rowIndex);
      let colInfo = this.table2D.gridModel.getColumn(data.cellName);
      let t2DColType = colInfo.t2DColType;
      let t2DColKey = colInfo.t2DColKey;
      let t2DRowKey = rowInfo.t2DRowKey;
      let t2DInfo_MultiCol = colInfo.t2DInfo_MultiCol;
      let originField = t2DInfo_MultiCol ? t2DInfo_MultiCol.originField : colInfo.fieldName;
      let matchedIndex = [];
      matchedIndex = self.getMatchedTable1DRowsByRowColKey(t2DColType, t2DRowKey, t2DColKey, true);
      if (t2DColType == "rowItem") {
        if (matchedIndex.length == 0) {
          this.LogRedInfo("当前修改的二维表单元格没有在一维表匹配到行，请检查。data  =" + JSON.stringify(data));
        }
        else {
          let changeIndexs = this.getTable1DChangedRows(t2DColType, matchedIndex, originField, data.value);
          if (changeIndexs.length > 0) {
            let relatedChangeObj = {};
            gridModel.execute('Table2DEvent_RelatedChangeRowItemCheck',
              {
                fieldName: data.cellName,
                value: data.value,
                t2DRow: rowInfo,
                relatedChangeObj
              }
            );
            if (this.checkCanChangeTable2DRowItem(data, relatedChangeObj) == true) {
              if (gridModel.execute('Table2DEvent_BeforeUpdate1DRows', { changeIndexs, data }) == false) return;
              if (typeof (data.value) == "object") {//colInfo.bCheck ||
                changeIndexs.forEach((index) => {
                  // gridModel.setCellValue(index, originField, data.value, true, false);
                  let obj = {};
                  Object.keys(data.value).forEach((key) => {
                    if (gridModel.hasColumn(key)) {
                      obj[key] = data.value[key];
                    }
                  })
                  obj = cb.utils.extend(true, obj, relatedChangeObj)
                  gridModel.updateRow(index, obj);
                });
              }
              else {
                let obj = {};
                obj[originField] = data.value;
                obj = cb.utils.extend(true, obj, relatedChangeObj)
                changeIndexs.forEach((index) => {
                  gridModel.updateRow(index, obj);
                })
              }
              if (_.isEmpty(relatedChangeObj) == false) {
                this.table2D.gridModel.updateRow(data.rowIndex, relatedChangeObj);
              }
              gridModel.execute('Table2DEvent_AfterUpdate1DRows', { changeIndexs, data });
            }
            else {
              bChangeOK = false;
            }
          }
        }
      }

      else if (t2DColType == "crossItem") {
        // self.table2D.gridModel.doPropertyChange('setCellBlur', data);
        if (matchedIndex.length == 0) {
          if (self.isNoValue(data.value) == false) {
            let index = self.getUnMatchedRowIndex(rowInfo.t2DRowKey);
            if (index >= 0) {

              let obj = { t2DInfoIn1DRow: { t2DColKey: t2DColKey } };
              let colItemData = self.config.colItemData;
              colItemData.fieldNames.forEach(fieldName => {
                obj[fieldName] = t2DInfo_MultiCol.valueArr[fieldName];
              });
              gridModel.updateRow(index, obj);//将未匹配的一维表行匹配到二维表的当前列下
              matchedIndex.push(index);
            }
            else {
              self.addRowInfo.addRowIsRunning = true;
              cb.utils.loadingControl.start();
              index = self.insertTable1DRowForInputCrossValue(rowInfo, colInfo, data);
              // self.calcRowCrossItemSum(false, data.rowIndex, data);
              setTimeout(() => {//在销售目标界面测试，录入数据后点击增行，界面显示有问题，所以使用setTimeOut
                // self.table2D.gridModel.doPropertyChange('setCellBlur', data);// 编辑物料档案，选择影响制造规格信息时，选中其中一个，另外一个也会被自动选中，取消时又会被一起取消。
                // setCellBlur放在 else if (t2DColType == "crossItem") {下没用，因为事件调用顺序原因，当前事件会在 table更改 CellStatus之前调用，所以无效
                // 因为当前事件是cell内部控件（比如checkradio触发），但是更改CellStatus（CellStatus[index][columnKey] = true;）是cell抛出
                self.groupSelected(self.group.selectedEle);
                cb.utils.loadingControl.end();
                self.addRowInfo.addRowIsRunning = false;
              }, 0);
              if (index >= 0) matchedIndex.push(index);
            }
          }
        }
        else if (matchedIndex.length == 1 && self.isNoValue(data.value) == true) {
          // 判断是否交叉点全是空，如果是则删一维表行
          let crossFields = self.config.crossItemData.fieldNames;
          let row = self.table1D.gridModel.getRow(matchedIndex[0]);
          let isEmpty = true;
          crossFields.forEach(
            (field) => {
              if (field != originField && self.isNoValue(row[field]) == false) {
                isEmpty = false;
              }
            });
          if (isEmpty) {
            //当前一维表行的交叉点值已经全清空，判断当前一维表行是否是当前二维表行在一维表中对应的唯一行
            //如果是唯一行，则清除列 t2dColKey；如果不是唯一行，则删除当前一维表的行
            // let rowArr = self.getMatchedTable1DRowsByRowColKey(t2DColType, t2DRowKey, undefined, true);
            let rowArr = self.getMatchedTable1DRowsByRowColKey("", t2DRowKey, undefined, true);
            if (rowArr.length == 1) {
              gridModel.updateRowNoEvent(matchedIndex[0], { t2DInfoIn1DRow: { t2DColKey: undefined } });
            }
            else {
              gridModel.deleteRows(matchedIndex);
              matchedIndex = [];
            }
          }
        }
        if (matchedIndex.length > 0) {
          if (matchedIndex.length > 1) {
            self.LogRedInfo("交叉点在一维表对应多行，请检查。data  =" + JSON.stringify(data));
          }
          let changeIndexs = self.getTable1DChangedRows(t2DColType, matchedIndex, originField, data.value);
          changeIndexs.forEach((index) => {
            gridModel.setCellValue(index, originField, data.value, true, false);
            // self.calcRowCrossItemSum(false, matchedIndex[0]);
          })
          return false;//此处对交叉点的修改，因为修改的数值可能不能通过业务组校验，所以不能直接修改二维表，返回false。通过监听一维表的afterCellValueChange事件来更新二维表的数值
        }
      }
      else if (t2DColType == "measureItem") {
        if (matchedIndex.length == 0) {
          this.LogRedInfo("当前修改的二维表单元格没有在一维表匹配到行，请检查。data  =" + JSON.stringify(data));
        }
        else {
          let changeIndexs333 = this.getTable1DChangedRows(t2DColType, matchedIndex, originField, data.value);
          if (changeIndexs333.length > 0) {
            if (gridModel.execute('Table2DEvent_MeasureItemValueChange', { data, changeIndexs333 }) == true) {
              if (typeof (data.value) == "object") {//colInfo.bCheck ||
                changeIndexs333.forEach((index) => {
                  // gridModel.setCellValue(index, originField, data.value, true, false);
                  let obj = {};
                  Object.keys(data.value).forEach((key) => {
                    if (gridModel.hasColumn(key)) {
                      obj[key] = data.value[key];
                    }
                  })
                  gridModel.updateRow(index, obj);
                });
              }
              else {
                let obj = {};
                obj[originField] = data.value;
                changeIndexs333.forEach((index) => {
                  gridModel.updateRow(index, obj);
                })
                self.calcTotalSum(false, data.cellName);
              }
            }
            else {
              bChangeOK = false;
            }
          }
        }
      }

      // if (changeIndexs.length == 0) {
      //   //一维表中没有对应的行，需要新增.按照逻辑，应该只有是交叉点才可能增行，指标值应该都在一维表有对应行
      //   if (t2DColType == "crossItem") {
      //     if (this.isNoValue(data.value) == false) {
      //       let index = self.getUnMatchedRowIndex(rowInfo.t2DRowKey);
      //       if (index >= 0) {
      //         gridModel.updateRow(index, { t2DInfoIn1DRow: { t2DColKey: t2DColKey } });//将未匹配的一维表行匹配到二维表的当前列下
      //         gridModel.setCellValue(index, originField, data.value, true, false);
      //       }
      //       else {
      //         this.insertTable1DRowForInputCrossValue(rowInfo, colInfo, data);
      //       }
      //     }
      //   }
      //   else {
      //     this.LogRedInfo("当前修改的二维表单元格没有在一维表匹配到行，请检查。data  =" + JSON.stringify(data));
      //   }
      // }
      // else {
      //   //一维表中有对应的行,而且数值的确改变了才触发
      //   changeIndexs = this.getTable1DChangedRows(t2DColType, changeIndexs, originField, data.value);
      //   if (changeIndexs.length > 0) {
      //     //一维表中有对应的行且进行了修改
      //     if (t2DColType == "measureItem") {
      //       if (this.table1D.gridModel.execute('Table2DEvent_MeasureItemValueChange', { data, changeIndexs }) == false) {
      //         bReturn = false;
      //       }
      //     }
      //     else if (t2DColType == "rowItem") {
      //       bReturn = this.checkCanChangeTable2DRowItem(data);
      //     }
      //     else if (t2DColType == "crossItem" && this.isNoValue(data.value) == true) {
      //     }
      //     if (bReturn) {
      //       if (colInfo.bCheck) {
      //         changeIndexs.forEach((index) => {
      //           gridModel.setCellValue(index, originField, data.value, true, false);
      //         });
      //         bReturn = false;//暂时返回false,等待计算完毕统一刷新
      //       }
      //       else if (typeof (data.value) == "object") {
      //         changeIndexs.forEach((index) => {
      //           gridModel.setCellValue(index, originField, data.value, true, false);
      //         })
      //         bReturn = true;
      //       }
      //       else {
      //         let obj = {};
      //         obj[originField] = data.value;
      //         changeIndexs.forEach((index) => {
      //           gridModel.updateRow(index, obj);
      //         })
      //         bReturn = true;
      //       }
      //     }
      //   }
      // }
    }
    this.LogInfo_All();
    return bChangeOK;
  }

  // Table2DEvent_SetCellBlur = (data) => {
  //   let self = this;
  //   if (self.show2D == true && self.addRowInfo.addRowIsRunning == false && self.addGroupInfo.addGroupIsRunning == false) {
  //     let gridModel = this.table2D.gridModel;
  //     gridModel.execute('Table2DEvent_SetCellBlur', data);
  //   }
  // }
  Table2DEvent_SetStates = (obj) => {
    let obj2 = {};
    if (obj.hasOwnProperty("visible")) {
      obj2.visible = !!obj.visible;
    }
    if (_.isEmpty(obj2) == false) {
      this.setState(obj2);
    }
  }

  Table2DEvent_SetGridStates = (obj) => {
    let gridModel = this.table2D.gridModel;
    let obj2 = {};
    if (obj.hasOwnProperty("subtotalData")) {
      obj2.subtotalData = obj.subtotalData;
    }
    if (_.isEmpty(obj2) == false) {
      gridModel.setState(obj2);
    }
  }

  Table2DEvent_GetColumnsAndData = () => {

    let gridModel = this.table2D.gridModel;
    let columns = gridModel.getColumns();
    let rows = gridModel.getRows();
    return { columns, rows }

  }
  Table2DEvent_RefreshConfig = (config) => {
    if (config && config.bClearData) {
      this.table1D.gridModel.clear();
    }
    this.chooseGroup();
  }

  afterTable1DCellValueChange = (data) => {
    this.LogInfo(" afterTable1DCellValueChange data = " + JSON.stringify(data));
    let self = this;
    if (self.show2D == true && self.addRowInfo.addRowIsRunning == false && self.addGroupInfo.addGroupIsRunning == false) {
      let row = self.table1D.gridModel.getRow(data.rowIndex);
      if (self.isInCrossItemFields(data.cellName)) {
        // || self.isInRowItemFields(data.cellName) 通过二维表修改行标题认为肯定成功，所以先不再回写
        self.setTable2DCrossItemValue(row.t2DInfoIn1DRow.t2DRowKey, row.t2DInfoIn1DRow.t2DColKey, data.cellName, data.value);
      }
      else if (self.isInMeasureItemFields(data.cellName)) {
        self.reCalcMeasureItemValue(row.t2DInfoIn1DRow.t2DRowKey, data.cellName);
        self.calcTotalSum(false, data.cellName);
      }
      else if (self.isInRowItemFields(data.cellName)) {
        //销售目标二维表界面的行标题 更改完“门店”之后，将“商品分类”“商品名称”“营业员”清空
        // let rowIndex = self.getMatchedTable2DRowByRowKey(row.t2DInfoIn1DRow.t2DRowKey);
        // let obj = {};
        // let fieldName = data.cellName;
        // obj[fieldName] = (data.value === undefined ? null : data.value);
        // self.table2D.gridModel.updateRow(rowIndex, obj);
      }
    }
    this.LogInfo_All();
  }

  isInCrossItemFields(field) {
    if (this.config.crossItemData.fieldNames.indexOf(field) >= 0)
      return true;
    else
      return false;
  }

  isInRowItemFields(field) {
    if (this.config.rowItemData.fieldNames.indexOf(field) >= 0)
      return true;
    else
      return false;
  }

  isInMeasureItemFields(field) {
    let columns = this.table2D.columns;
    if (columns[field] && columns[field].t2DColType == "measureItem")
      return true;
    else
      return false;
  }

  setTable2DCrossItemValue(t2DRowKey, t2DColKey, originField, value) {

    let self = this;
    let cols = self.getMatchedTable2DColsByColKeyAndOriginField(t2DColKey, originField);
    let rowIndex = self.getMatchedTable2DRowByRowKey(t2DRowKey);
    if (rowIndex >= 0 && cols.length > 0) {
      let obj = {};
      let fieldName = cols[0].fieldName;
      obj[fieldName] = value;
      self.table2D.gridModel.updateRow(rowIndex, obj);
      self.calcRowCrossItemSum(false, rowIndex);
    }
  }

  getRandomKey(str) {
    return str + Math.floor(Math.random() * 10000000000);
  }

  onOk = (e) => {
    // insertRows = function (rowIndex, rowDatas)
    // let validDataSource = this.getValidDataSource();
    // if (validDataSource.length> 0) {
    // let gridModel = this.table1D.gridModel;
    // let length = gridModel.getRowsCount();
    // gridModel.setReadOnly(false);
    // gridModel.deleteRows(this.table1D.focusedIndex);
    // gridModel.insertRows(this.table1D.focusedIndex, validDataSource);
    // }
    if (this.table2DValidCheck()) {
      this.doClose();
    }
  }

  onCancel = (e) => {
    // let gridModel = this.table1D.gridModel;
    // gridModel.updateRow(this.table1D.focusedIndex, this.config.originRowBackup);
    if (this.table2DValidCheck()) {
      this.doClose();
    }
  }

  doClose() {
    this.bInitHasErr = true;
    if (this.props.close)
      this.props.close(true);
  }

  LogRedInfoAndAlert(info) {
    this.LogRedInfo(info);
    cb.utils.alert(info);
  }

  LogRedInfo(info) {
    this.LogInfo(info, true, true);
  }

  LogInfo_All() {
    this.LogInfo("所有信息-分组数据 group = " + JSON.stringify(this.group));
    this.LogInfo("所有信息-配置信息 config = " + JSON.stringify(this.config));

    let tmpTable1DRows = (this.table1D.gridModel && this.table1D.gridModel.getRows()) || [];
    let tmpTable2DRows = (this.table2D.gridModel && this.table2D.gridModel.getRows()) || [];
    this.LogInfo("所有信息-一维表数据 getRows  length =" + tmpTable1DRows.length + " info = " + JSON.stringify(tmpTable1DRows));
    this.LogInfo("所有信息-二维表数据 getRows  length =" + tmpTable2DRows.length + " info = " + JSON.stringify(tmpTable2DRows));
    this.LogInfo("所有信息-二维表栏目 columns = " + (this.table2D.columns && JSON.stringify(this.table2D.columns)));
    this.table1D.gridModel.t2DInfo_Bus_Log();
  }

  LogInfo(info, bMust, bRed) {
    if (this.needLog || bMust || bRed) {
      if (!(typeof (info) == "string" || typeof (info) == "number"))
        info = JSON.stringify(info);
      if (bRed)
        console.log('%c 二维表日志 警告', 'color:red;', info);
      else
        console.log("二维表日志 " + info);
    }
  }

  //整理GroupData并选择某一个
  setGroupDataAndChooseGroup() {
    this.setTable1DGroupReferModel();
    this.setGroupFieldsData();
    this.chooseGroup();
    this.setActionsState();

  }

  componentWillReceiveProps(nextProps) {
    this.show2D = nextProps.show2D;
    if (nextProps.show2D == true && this.props.show2D == false) {
      if (this.isConfigOKAndDataLoaded() == true) {
        // this.setTable1DFocusedInfo();
        this.setGroupDataAndChooseGroup();
      }
    }
  }

  isConfigOKAndDataLoaded() {//不需要配置文件或者配置文件已获取  并且  首页不显示二维表或者一维表数据已经加载
    let self = this;
    if ((self.billConfig.hasBillConfig === false || self.billConfig.billConfigIsLoad == true) && (self.show2DInBegin == false || self.table1DDataLoaded == true)) {
      return true;
    }
    else {
      return false;
    }
  }

  //选择合适的Group显示
  chooseGroup() {
    let self = this;
    if (this.isConfigOKAndDataLoaded() == true) {
      if (self.group.hasGroup == true && self.group.fieldsData.length > 0) {//self.group.selectedEle == undefined &&
        let ele;
        let focusedIndex = this.table1D.gridModel ? this.table1D.gridModel.getFocusedRowIndex() : -1;
        if (focusedIndex >= 0) {
          let focusedCode = this.table1D.gridModel.getRows()[focusedIndex][this.group.fields.codeField];
          ele = _.find(self.group.fieldsData, function (o) { return o.code == focusedCode })
        }
        if (!ele) {
          ele = self.group.fieldsData[0];
        }
        self.groupSelected(ele, true);
      }
      else if (self.group.hasGroup === false) {
        self.groupSelected(undefined, true);
      }
    }
  }

  componentDidMount() {
    // this.table2DTabIsDisplay = true;
    this.unSetTrigger_1D();
    this.setTrigger_1D();
  }

  componentWillUnmount() {
    this.unSetTrigger_1D();
    this.unSetTrigger_2D();
  }

  setRowModelValue(obj, fieldName, fieldValue, rowInfo) {
    // let value = fieldValue;
    // let self = this;
    let fieldObj;
    let fieldObjs = this.config.rowItemData.fieldObjs;
    let fieldArr = fieldObjs && fieldObjs[fieldName];
    if (fieldArr && fieldArr.length > 0) {
      let valueObj = _.find(fieldArr, function (o) { return o.fieldValue == fieldValue })
      fieldObj = valueObj && valueObj.fieldObj;
    }
    if (_.isEmpty(fieldObj)) {
      obj[fieldName] = fieldValue;
    }
    else if (fieldObj.hasOwnProperty("enumKey")) {
      obj[fieldName] = fieldObj.enumKey;
    }
    else {
      obj[fieldName] = fieldValue;
      obj = Object.assign(obj, fieldObj);
    }
    return obj;
  }

  setColModelValue(valueArr, fieldName, titleValue) {
    //  t2DInfo_MultiCol.valueArr[colItemData.fieldNames[index]] = self.getColModelValue(colItemData.fieldNames[index], titleValue);
    // let value = titleValue;
    let fieldObj;
    let fieldObjs = this.config.colItemData.fieldObjs;
    let fieldArr = fieldObjs && fieldObjs[fieldName];
    if (fieldArr && fieldArr.length > 0) {
      let valueObj = _.find(fieldArr, function (o) { return o.fieldValue == titleValue })
      fieldObj = valueObj && valueObj.fieldObj;
    }
    if (_.isEmpty(fieldObj)) {
      valueArr[fieldName] = titleValue;
    }
    else if (fieldObj.hasOwnProperty("enumKey")) {
      valueArr[fieldName] = fieldObj.enumKey;
    }
    else {
      valueArr[fieldName] = titleValue;
      valueArr = Object.assign(valueArr, fieldObj);
    }
    return valueArr;
  }

  //根据配置文件的配置信息和行、列标题的值，生成二维表栏目和数据
  initTable2DColumns() {
    let config = this.config;
    let self = this;
    let columns2 = {};
    let rowItemData = config.rowItemData;
    let colItemData = config.colItemData;
    let crossFields = config.crossItemData.fieldNames;
    let gridModel = this.table1D.gridModel;

    // let originRows = [];
    // let originDataSource = [];

    //分组
    // if (this.group.fields.codeField) {
    // let fieldName = this.group.fields.codeField;
    // let column = gridModel.getColumn(fieldName);
    // column.t2DColType = "group";
    // column.bCanModify = false;
    // columns2[fieldName] = column;
    // columns2[fieldName].iOrder = Object.keys(columns2).length + 1;
    // }

    // if (this.group.fields.nameField) {
    // let fieldName = this.group.fields.nameField;
    // let column = gridModel.getColumn(fieldName);
    // column.t2DColType = "group";
    // column.bCanModify = false;
    // columns2[fieldName] = column;
    // columns2[fieldName].iOrder = Object.keys(columns2).length + 1;
    // }

    //根据行标题的字段名，生成栏目
    if (_.isEmpty(rowItemData) == false && _.isEmpty(rowItemData.fieldNames) == false) {
      rowItemData.fieldNames.forEach(fieldName => {
        let column = gridModel.getColumn(fieldName);
        column.t2DColType = "rowItem";
        // column.bCanModify = true;
        columns2[fieldName] = column;
        columns2[fieldName].iOrder = Object.keys(columns2).length + 1;
        if (rowItemData.fieldHide.indexOf(fieldName) >= 0) {
          column.bShowIt = false;
        }
        else {
          column.bShowIt = true;
        }
      });
    }

    let multiCols = [];
    let emptyMultiCol = { valueArr: {}, originField: "" };

    if (colItemData.fieldNames.length > 0 && colItemData.fieldValues.length > 0) {
      colItemData.fieldValues.forEach((titleValueArr) => {
        let obj = {};
        let t2DInfo_MultiCol = _.cloneDeep(emptyMultiCol);
        if (_.isEmpty(titleValueArr) == false) {
          titleValueArr.forEach((titleValue, index) => {

            // t2DInfo_MultiCol.valueArr[colItemData.fieldNames[index]] = self.setColModelValue(colItemData.fieldNames[index], titleValue);
            t2DInfo_MultiCol.valueArr = self.setColModelValue(t2DInfo_MultiCol.valueArr, colItemData.fieldNames[index], titleValue);

          })
          colItemData.fieldMultiCol.forEach((fieldName) => {
            let index = _.indexOf(colItemData.fieldNames, fieldName);
            let titleValue = titleValueArr[index];
            let obj2 = {};
            if (_.isEmpty(obj)) {
              obj2.cFieldName = "field" + titleValue;
              obj2.path = "field" + titleValue;
            }
            else {
              obj2.cFieldName = titleValue;
              obj2.path = obj.path + "|" + titleValue;
              obj2.parent = obj;
            }
            obj2.cCaption = titleValue;
            obj2.cShowCaption = titleValue;
            obj2.bVmExclude = 0;
            obj2.iOrder = 0;
            obj2.uncopyable = false;
            obj = obj2;
          })
        }
        obj.t2DInfo_MultiCol = t2DInfo_MultiCol;
        multiCols.push(obj);
      })
    }

    // let multiCols = [];
    // if (colItemData.fieldNames.length> 0 && colItemData.fieldValues.length> 0) {
    // colItemData.fieldValues.forEach((titleValueArr) => {
    // let obj = {};
    // let t2DInfo_MultiCol = _.cloneDeep(emptyMultiCol);
    // if (_.isEmpty(titleValueArr) == false) {
    // titleValueArr.forEach((titleValue, index) => {
    // let obj2 = {};
    // let cFieldName = "";
    // let path = "";
    // if (_.isEmpty(obj)) {
    // obj2.cFieldName = "field" + titleValue;
    // obj2.path = "field" + titleValue;
    // }
    // else {
    // obj2.cFieldName = titleValue;
    // obj2.path = obj.path + "|" + titleValue;
    // obj2.parent = obj;
    // }
    // obj2.cCaption = titleValue;
    // obj2.cShowCaption = titleValue;
    // obj2.bVmExclude = 0;
    // obj2.iOrder = 0;
    // obj2.uncopyable = false;
    // obj = obj2;
    // t2DInfo_MultiCol.valueArr[colItemData.fieldNames[index]] = titleValue;

    // })
    // }
    // obj.t2DInfo_MultiCol = t2DInfo_MultiCol;
    // multiCols.push(obj);
    // })
    // }

    //生成 originDataSource 所需要的初始的行信息 originRows。每个multiCols 列对应一行初始行信息
    //根据前面的 multiCols和交叉点数据，生成最终的交叉点栏目，比如数量，单价栏目。
    // let originRowTpl = this.GetSourceOriginTpl(gridModel, this.table1D.focusedIndex, config);//原始行数据
    if (multiCols.length > 0) {
      multiCols.forEach((multiCol, index) => {
        let t2DColKey = this.getRandomKey("Col_");
        // let tmpSourceOriginRow = _.cloneDeep(originRowTpl);
        // tmpSourceOriginRow.t2DColKey = t2DColKey;
        // tmpSourceOriginRow = Object.assign(tmpSourceOriginRow, multiCol.t2DInfo_MultiCol);
        // originRows.push(tmpSourceOriginRow);
        crossFields.forEach(
          (field) => {
            let col = _.cloneDeep(self.table1D.gridModel.getColumn(field));
            if (crossFields.length == 1 && self.bMustShowCrossTitle == false) {
              col.cCaption = multiCol.cCaption;
              col.cShowCaption = multiCol.cShowCaption;
            }

            else {
              col.parent = multiCol;
            }
            col.t2DInfo_MultiCol = _.cloneDeep(multiCol.t2DInfo_MultiCol);
            col.t2DInfo_MultiCol.originField = field;
            let cFieldName = multiCol.path + "|" + field
            col.cFieldName = cFieldName;
            col.cItemName = cFieldName;
            col.fieldName = cFieldName;
            // col.bCanModify = true;
            col.cFormatData = undefined;
            col.iNumPoint = self.getNumPoint(field, col.iNumPoint);
            col.path = cFieldName;
            col.t2DColType = "crossItem";
            col.iOrder = Object.keys(columns2).length + 1;
            col.t2DColKey = t2DColKey;
            columns2[cFieldName] = col;
          }
        )
        delete multiCol.t2DInfo_MultiCol;
      })
    }
    else {
      let t2DColKey = this.getRandomKey("Col_");
      // let tmpSourceOriginRow = _.cloneDeep(originRowTpl);
      // tmpSourceOriginRow.t2DColKey = t2DColKey;
      // // tmpSourceOriginRow = Object.assign(tmpSourceOriginRow, multiCol.t2DInfo_MultiCol);
      // originRows.push(tmpSourceOriginRow);
      crossFields.forEach(
        (field) => {
          let col = _.cloneDeep(self.table1D.gridModel.getColumn(field));
          col.t2DInfo_MultiCol = _.cloneDeep(emptyMultiCol);
          col.t2DInfo_MultiCol.originField = field;
          let cFieldName = field
          col.cFieldName = cFieldName;
          col.cItemName = cFieldName;
          col.fieldName = cFieldName;
          col.cFormatData = undefined;
          col.iNumPoint = self.getNumPoint(field, col.iNumPoint);
          col.path = cFieldName;
          col.t2DColType = "crossItem";
          col.iOrder = Object.keys(columns2).length + 1;
          col.t2DColKey = t2DColKey;
          columns2[cFieldName] = col;
        }
      )
    }

    // 增加交叉点后的列小计
    if (self.hide2DSum != true) {
      crossFields.forEach(
        (field) => {
          let col = _.cloneDeep(self.table1D.gridModel.getColumn(field));
          col.t2DSumField = field;
          let cFieldName = "crossItemSum_" + field;
          col.cFieldName = cFieldName;
          col.cItemName = cFieldName;
          col.fieldName = cFieldName;
          col.cFormatData = undefined;
          col.bCanModify = false;
          col.bIsNull = true;
          col.bShowIt = true;
          col.bMustSelect = false;
          col.bNeedSum = true;
          col.iNumPoint = self.getNumPoint(field, col.iNumPoint);
          if (crossFields.length == 1) {
            col.cCaption = "小计";
          }
          else {
            col.cCaption = "小计(" + col.cCaption + ")";
          }
          col.cShowCaption = col.cCaption;
          col.t2DColType = "crossItemSum";
          col.iOrder = Object.keys(columns2).length + 1;
          columns2[cFieldName] = col;
        }
      );
    }

    //设置显示隐藏
    Object.values(columns2).forEach((col) => {
      if (col.t2DColType != "rowItem") {
        col.bShowIt = true;
        col.bHidden = false;
      }
    })
    let measureColumns = this.getMeasureColumnsFromTable1D();
    columns2 = cb.utils.extend(columns2, measureColumns);
    this.table2D.columns = columns2;
    // this.originDataSource = originDataSource;
  }

  isFieldInConfig(fieldName) {
    let rowItemFields = this.config.rowItemData.fieldNames;
    let colItemFields = this.config.colItemData.fieldNames;
    let crossFields = this.config.crossItemData.fieldNames;
    let groupFields = this.group.fields;
    if (
      rowItemFields.indexOf(fieldName) >= 0 ||
      colItemFields.indexOf(fieldName) >= 0 ||
      crossFields.indexOf(fieldName) >= 0 ||
      groupFields.idField == fieldName ||
      groupFields.codeField == fieldName ||
      groupFields.nameField == fieldName
    )
      return true;
    else
      return false;
  }

  getMeasureColumnsFromTable1D() {
    let cols = {};
    let columns = this.table1D.gridModel.getColumns();
    Object.values(columns).forEach((col) => {
      // if (col.bHidden == false && col.bShowIt == true) {
      if (this.isFieldInConfig(col.fieldName) == false) {
        // col.bCanModify = true;
        cols[col.fieldName] = col;
        col.t2DColType = "measureItem";
      }
      // }
    });
    return cols;
  }

  reCalcMeasureItemValue(t2DRowKey, fieldName) {
    let self = this;
    let matchRows = this.getMatchedTable1DRowsByRowColKey("", t2DRowKey, "", false);
    if (matchRows.length > 0) {
      let col = this.table1D.gridModel.getColumn(fieldName);
      let measureValue = this.getMeasureValue(col, matchRows);
      let rowIndex = this.getMatchedTable2DRowByRowKey(t2DRowKey);
      if (rowIndex >= 0) {
        let obj = {};
        obj[fieldName] = measureValue;
        self.table2D.gridModel.updateRow(rowIndex, obj);
      }
    }
  }

  getMeasureValues(dataSource) {
    let measureColumns = _.filter(this.table2D.columns, function (o) { return o.t2DColType == "measureItem" });
    dataSource.forEach((row) => {
      let t2DRowKey = row.t2DRowKey;
      let matchRows = this.getMatchedTable1DRowsByRowColKey("", t2DRowKey, "", false);
      if (matchRows.length > 0) {
        measureColumns.forEach((col) => {
          let measureValue = this.getMeasureValue(col, matchRows);
          row[col.fieldName] = measureValue;
        })
      }
      else {
        this.LogInfo("getMeasureValues没有在一维表找到 t2DRowKey = " + t2DRowKey + " 对应的行。");
      }
    })
    return dataSource;
  }

  getMeasureValue(col, rows) {
    if (col.cSumType) {
      return this.getSumData(rows, col);
    }
    else {
      return rows[0][col.fieldName];
    }
  }

  getSumData(data, column, relatedName, defaultType) {
    if (relatedName && !column) {
      column = this.table1D.gridModel.getColumn(relatedName);
    }
    if (!column) return 0;
    let cItemName = column.fieldName;
    let cSumType = column.cSumType;
    if (!cb.utils.isEmpty(defaultType) && cb.utils.isEmpty(cSumType)) cSumType = defaultType;
    if (cb.utils.isEmpty(cSumType)) cSumType = 'sum';
    cSumType = cSumType.toLocaleLowerCase();
    let sumData = null;
    switch (cSumType) {
      case 'max':
        data.map(row => {
          let val = row[cItemName];
          if (cb.utils.isEmpty(sumData))
            sumData = cb.utils.isEmpty(val) ? 0 : val;
          if (val > sumData) sumData = val;
        });
        break;
      case 'min':
        data.map(row => {
          let val = row[cItemName];
          if (cb.utils.isEmpty(sumData))
            sumData = cb.utils.isEmpty(val) ? 0 : val;
          if (val < sumData) sumData = val;
        });
        break;
      case 'avg':
        data.map(row => {
          let val = row[cItemName];
          val = val || 0;
          sumData = sumData + parseFloat(val);
        });
        if (data.length > 0) sumData = sumData / data.length;
        break;
      case 'count':
        sumData = data.length;
        break;
      case 'sum':
        if (cb.utils.isEmpty(sumData)) sumData = 0;
        data.map(row => {
          let val = row[cItemName];
          val = val || 0;
          sumData = getMultiplication(sumData, val, 'add');
        });
        break;
      default:/*其余全部取第一个处理*/
        sumData = data && data[0] && data[0][cItemName];
        break;
    }
    if (cb.utils.isEmpty(sumData)) sumData = 0;
    sumData = this._getDecimal(data, column, sumData);
    return sumData;
  }

  _getDecimal(data, col, sum) {
    let self = this;
    let NumPoint = col.iNumPoint;
    /*谓词变量支持系统参数*/
    let cFormatData = col.cFormatData;
    try {
      if (!cFormatData || cFormatData == '') {
        cFormatData = {};
      } else {
        cFormatData = JSON.parse(cFormatData);
      }
    } catch (e) {
      console.error('数量/金额/单价，预制错误！');
    }
    let relatedName = cFormatData.related;
    if (relatedName && !relatedName.startsWith('parentdata.')) {
      NumPoint = this.getSumData(data, undefined, relatedName, 'max');
    }
    let decimal = cFormatData.decimal ? getPredicateValue(cFormatData.decimal) : null;
    let controlType = col.cControlType ? col.cControlType.trim().toLocaleLowerCase() : '';
    if (controlType === 'money') {
      cFormatData.splitter = true
      if (decimal)
        NumPoint = decimal;
      else
        NumPoint = cb.rest.AppContext.option.amountofdecimal;
    } else if (controlType === 'price') {
      if (decimal)
        NumPoint = decimal;
      else
        NumPoint = cb.rest.AppContext.option.monovalentdecimal;
    } else if (controlType === 'inputnumber') {
      if (decimal)
        NumPoint = decimal;
      else
        if (!NumPoint || NumPoint == '') NumPoint = 0;
    } else {
      NumPoint = null;
    }
    if (!isNaN(NumPoint) && NumPoint != null) {
      /*add by jinzh1 tofixed函数 最大支持100*/
      if (NumPoint > 100) NumPoint = 100;
      sum = parseFloat(sum);
      sum = getRoundValue(sum, NumPoint);
      if (cFormatData.splitter) { // add 千分位
        sum = self.formatter(sum);
      }
    }
    return sum;
  }

  formatter = (value) => {
    let _value = (value + '');
    let _valueArr = _value.split('.');
    if (_valueArr.length == 1) {
      return `${_value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
    } else {
      _valueArr[0] = _valueArr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return `${_valueArr.join('.')}`;
    }
  }

  //检查值是否相同
  isEqualValue(value1, value2) {
    if (typeof (value1) == "object" && typeof (value2) == "object" && _.isEmpty(value1) && _.isEmpty(value2))
      return true;
    else if (_.isEqual(value1, value2))
      return true;
    else if (
      (value1 === undefined || value1 === null || value1 === "")
      &&
      (value2 === undefined || value2 === null || value2 === "")
    ) {
      return true;
    }
    else if (value1 == value2)
      return true;
    else
      return false;
  }

  // 查找一维表中的匹配行.如果valueArr有值，则是匹配交叉点单元格，一维表的匹配行应该唯一
  getMatchedTable1DRowByRowColValue(rows, rowItemMatchInfo, valueArr, t2DRowKey, t2DColKey) {
    let self = this;
    let matchArr = [];
    rows.forEach((row, index) => {
      if (row.t2DInfoIn1DRow.isShow) {
        let bMatch = true;
        Object.keys(rowItemMatchInfo).forEach((field) => {
          if (bMatch == true) {
            bMatch = self.isEqualValue(row[field], rowItemMatchInfo[field]);
          }
        })

        if (_.isEmpty(valueArr) == false) {
          Object.keys(valueArr).forEach((field) => {
            if (bMatch == true) {
              bMatch = self.isEqualValue(row[field], valueArr[field]);
            }
          })
        }
        if (bMatch)
          matchArr.push(index);
      }
    })
    if (_.isEmpty(valueArr) == false) {
      if (matchArr.length > 1) {
        this.LogRedInfo("匹配一维表的行时，有多个匹配行，请检查。 rows = " + JSON.stringify(rows));
        this.LogRedInfo("匹配一维表的行时，有多个匹配行，请检查。 rowItemMatchInfo = " + JSON.stringify(rowItemMatchInfo));
        this.LogRedInfo("匹配一维表的行时，有多个匹配行，请检查。 valueArr = " + JSON.stringify(valueArr));
        this.LogRedInfo("匹配一维表的行时，当前行前面已经匹配过，请检查。 matchArr = " + JSON.stringify(matchArr));
      }
      else if (matchArr.length == 1) {
        let row = rows[matchArr[0]];
        if (row.t2DInfoIn1DRow && row.t2DInfoIn1DRow.t2DColKey != "" && row.t2DInfoIn1DRow.t2DRowKey != "") {
          if (row.t2DInfoIn1DRow.t2DColKey != t2DColKey || row.t2DInfoIn1DRow.t2DRowKey != t2DRowKey) {
            this.LogRedInfo("匹配一维表的行时，当前行前面已经匹配过，请检查。 rows = " + JSON.stringify(rows));
            this.LogRedInfo("匹配一维表的行时，当前行前面已经匹配过，请检查。 rowItemMatchInfo = " + JSON.stringify(rowItemMatchInfo));
            this.LogRedInfo("匹配一维表的行时，当前行前面已经匹配过，请检查。 valueArr = " + JSON.stringify(valueArr));
            this.LogRedInfo("匹配一维表的行时，当前行前面已经匹配过，请检查。 matchArr = " + JSON.stringify(matchArr));
          }
        }
      }
    }
    // check End
    return matchArr;
  }

  //初始化默认的一维表行
  getTable1DDefaultRowObj(defaultValueObj) {
    defaultValueObj = defaultValueObj || {};
    if (this.group.hasGroup) {
      let selectedEle = this.group.selectedEle;
      defaultValueObj[this.group.fields.idField] = selectedEle.id;
      defaultValueObj[this.group.fields.codeField] = selectedEle.code;
      defaultValueObj[this.group.fields.nameField] = selectedEle.name;
    }
    return defaultValueObj;
  }

  //初始化默认的二维表行
  getTable2DDefaultRow() {
    let obj = {};
    let selectedEle = this.group.selectedEle;
    if (this.group.hasGroup) {
      obj[this.group.fields.codeField] = selectedEle.code;
      obj[this.group.fields.nameField] = selectedEle.name;
    }
    return obj;
  }

  setTable1DGroupReferModel() {
    let self = this;
    if (self.group.hasGroup == true) {
      let groupReferModel = this.getTable1DFieldModelInEditRowModel(this.group.fields.codeField);
      if (groupReferModel && groupReferModel.modelType == "ReferModel") {
        if (this.table1D.groupReferModel) {
          this.table1D.groupReferModel.un('beforeBrowse', self.addGroup_Table1D_GroupReferModal_BeforeBrowse);
          this.table1D.groupReferModel.un('afterBrowse', self.addGroup_Table1D_GroupReferModal_AfterBrowse);
        }
        groupReferModel.on('beforeBrowse', self.addGroup_Table1D_GroupReferModal_BeforeBrowse);
        groupReferModel.on('afterBrowse', self.addGroup_Table1D_GroupReferModal_AfterBrowse);
        // groupReferModel && groupReferModel.setState('readOnly', false);
        this.table1D.groupReferModel = groupReferModel;
      }
      else {
        this.LogRedInfo("初始化没有找到一维表editRowModel或者editRowModel中没找到物料Model或者物料Model类型不是ReferModel");
      }
    }
  }

  clearGroupReferModelValue() {
    this.table1D.groupReferModel && this.table1D.groupReferModel.setState("value", "");
    // this.table1D.groupReferModel.setState("disabled", true);
  }

  getTable1DEditRowModel() {
    return this.table1D.gridModel && this.table1D.gridModel.getEditRowModel();
  }

  getTable1DFieldModelInEditRowModel(field) {
    let model = this.getTable1DEditRowModel();
    return model && model.get(field);
  }

  //设置左侧物料分组的数据
  setGroupFieldsData() {
    let arr = [];
    let rows = this.table1D.gridModel.getRows();
    if (rows.length < 1) {
      this.LogInfo("原始gridmodel没数据");
    }
    if (this.group.hasGroup) {
      rows.forEach((row) => {
        let id = row[this.group.fields.idField];
        let code = row[this.group.fields.codeField];
        let name = row[this.group.fields.nameField];
        if (this.isNoValue(id) == false && this.isNoValue(code) == false && _.findIndex(arr, function (o) { return o.code == code }) < 0) {
          arr.push({
            id,
            code,
            name,
            caption: name + "(" + code + ")",
            groupKey: this.getRandomKey("Group_")
          });
        }
      })
    }
    this.group.fieldsData = arr;
  }

  onMouseEnter1 = (groupKey) => {
    this.setState({ focusedGroupKey: groupKey });
  }

  onMouseLeave1 = () => {
    this.setState({ focusedGroupKey: "" });
  }

  onMouseEnter2 = () => {
    this.setState({ focusedGroupKeyIn: true });
  }

  onMouseLeave2 = () => {
    this.setState({ focusedGroupKeyIn: false });
  }

  getGroupFieldsRender() {
    let self = this;
    let arr = [];
    if (this.group.fieldsData && this.group.fieldsData.length > 0)
      this.group.fieldsData.forEach((ele) => {
        let selEle = this.group.selectedEle || {};
        let tmpClassName = "Table2D_Group";
        if (selEle.code == ele.code) {
          tmpClassName = tmpClassName + " Table2D_GroupSelected";
        }
        else {
          // tmpClassName = tmpClassName + " Table2D_GroupUnSelected";
        }
        if (self.state.focusedGroupKey == ele.groupKey) {
          tmpClassName = tmpClassName + " Table2D_GroupFocused";
        }
        else {
          // tmpClassName = tmpClassName + " Table2D_GroupUnFocused";
        }
        arr.push(<div
          className={tmpClassName}
          onMouseEnter={() => this.onMouseEnter1(ele.groupKey)}
          onMouseLeave={() => this.onMouseLeave1()}
        >
          <div className="Table2D_GroupName" onClick={() => this.groupFieldsClick(ele)}>
            {ele.caption}
          </div>
          {/* <SvgIcon className="icon-delete" type="delete" onClick={() => this.delGroup(ele)} /> */}
          {/* <Button className="Table2D_GroupDel" onClick={() => this.delGroup(ele)}>删除</Button> */}
          <div
            className="Table2D_GroupDel"
            onClick={() => this.delGroup(ele)}
            onMouseEnter={() => this.onMouseEnter2()}
            onMouseLeave={() => this.onMouseLeave2()}
            style={{ display: self.state.focusedGroupKey == ele.groupKey ? '' : 'none' }}
          >
            <SvgIcon type={self.state.focusedGroupKeyIn ? "biaogeshanchuxuanting" : "shanchu1"} />
          </div>
          {/* biaogeshanchuxuanting shanchu1 */}
        </div>)

      })
    return arr;
  }

  getTableRender() {
    let actions = this.props.actions;

    let action = {};
    action.cAlign = "left";
    action.cControlType = "Toolbar";
    action.cDataSourceName = "Toolbar";
    action.controls = [];
    let delControl = actions && actions.controls && _.find(actions.controls, function (o) { return o.cItemName == "btnDeleteRow" })
    if (delControl) {
      action.controls.push({
        cCaption: delControl.cCaption,
        cControlType: "button",
        cItemName: "btnDeleteRow",
        cShowCaption: delControl.cShowCaption,
        iOrder: 2,
        iStyle: 0,
        icon: "shanchu1",
        key: "ABC231626"
      }
      );
    }

    return <div className="Table2D_Table">
      <Table
        width={this.group.hasGroup ? (this.props.width - 300) : this.props.width}
        height={this.props.height}
        action={action}
        noViewModel={true}
        onActionClick={this.onActionClick}
        model={this.table2D.gridModel}
        T2D_TableNum={"2D"}
        showAggregates={!this.hide2DSum && this.group.hasGroup}//是否显示合计
        showSubtotal={!this.hide2DSum}//是否显示小计
        bCalcHeight={this.props.bCalcHeight}
      />
    </div>;
  }

  onActionClick = (index, action) => {
    //btnDeleteRow delRow(index)
    if (action.cItemName == "btnDeleteRow") {
      this.delRow(index);
    }
  }

  //某个物料的config配置以及各种配置数据处理，跟着物料走
  checkGroupAndSetConfig(ele, bFirst) {
    let config = this.getConfig_Interface(ele);
    this.checkFieldsInColumn(ele, config);
    let bFlag = this.setGroupConfigData(ele, config);
    if (bFlag) {
      this.setConfigData_Interface(ele, config);
      this.config = config;
      return true;
    }
    else {
      if (bFirst) {
        this.doClose();
      }
      else {
        this.LogRedInfo("切换失败。");
      }
      return false;
    }
  }

  groupFieldsClick(ele) {
    if (this.table2DValidCheck(false)) {
      this.groupSelected(ele);
    }
  }

  //当前显示二维表的可切换校验逻辑
  table2DValidCheck(bSave) {
    let self = this;
    let gridModel = this.table2D.gridModel;
    let rows = gridModel && gridModel.getRows();

    let rowItemFields = this.config.rowItemData && this.config.rowItemData.fieldNames;
    let crossFields = this.config.crossItemData && this.config.crossItemData.fieldNames;
    rows && rows.forEach((row) => {
      rowItemFields.forEach((field) => {
        if (self.isEqualValue(row[field], ""))
          row[field] = "";
      });
      crossFields.forEach((field) => {
        if (self.isEqualValue(row[field], ""))
          row[field] = "";
      });
    })

    let arr_CheckRepeat = [];
    if (rows) {
      for (let i = 0; i < rows.length; i++) {
        let row = rows[i];
        let obj = {};
        rowItemFields.forEach((field) => {
          obj[field] = row[field];
        });

        let index = _.findIndex(arr_CheckRepeat, (obj2) => { return _.isEqual(obj2, obj) });
        if (index >= 0) {
          this.LogRedInfoAndAlert("存在行标题重复的行" + (index + 1) + " " + (i + 1) + "，请检查。");
          return false;
        }
        else {
          arr_CheckRepeat.push(obj);
        }
      }
    }
    return true;
  }

  //根据当前的行列标题，交叉点的字段，校验能否切换到二维显示，并根据一维表已有的数据给行标题和列标题赋值
  setGroupConfigData(ele, config) {
    let self = this;
    let gridModel = this.table1D.gridModel;
    let rowFields = config.rowItemData.fieldNames;
    let colFields = config.colItemData.fieldNames;
    let rows = [];
    if (self.group.hasGroup) {
      rows = _.filter(gridModel.getRows(), function (o) {
        return o[self.group.fields.codeField] == ele.code
      });
    }
    else {
      rows = gridModel.getRows();
    }

    let arr_CheckRepeat = [];
    let arr_RowValues = [];
    let arr_ColValues = [];
    //检查值为空的行和重复行，整理行标题列标题的值
    try {
      config.rowItemData.fieldValues && config.rowItemData.fieldValues.forEach((ele) => {
        arr_RowValues.push(JSON.stringify(ele));
      });
      rows.forEach((row) => {
        let obj = {};
        let rowValue = [];
        let colValue = [];
        let isColValueError = false;//列的值是否有效
        rowFields.forEach((field) => {
          let value = row[field] || "";
          // if (self.isNoValue(value)) {
          // throw new Error("存在行标题的值为空的行。" + ele.code + " " + ele.name + " fieldName=" + field);
          // }
          obj[field] = value;
          rowValue.push(value);
        });
        colFields.forEach((field) => {
          let value = row[field] || "";
          if (this.isNoValue(value)) {
            // throw new Error("存在列标题的值为空的行。" + ele.code + " " + ele.name + " fieldName=" + field);
            isColValueError = true;
          }
          obj[field] = value;
          colValue.push(value);
        });
        arr_CheckRepeat.push(JSON.stringify(obj));
        arr_RowValues.push(JSON.stringify(rowValue));
        if (isColValueError == false) {
          arr_ColValues.push(JSON.stringify(colValue));
        }
      });
    }
    catch (e) {
      this.LogRedInfoAndAlert(e.message);
      return false;
    }
    // arr_CheckRepeat = arr_CheckRepeat.sort(function (a, b) { return a> b });
    arr_CheckRepeat = arr_CheckRepeat.sort();

    // arr_RowValues = _.sortBy(_.uniq(arr_RowValues));
    // arr_ColValues = _.sortBy(_.uniq(arr_ColValues));
    arr_RowValues = _.uniq(arr_RowValues);
    arr_ColValues = _.uniq(arr_ColValues);

    //检查重复行
    if (arr_CheckRepeat.length > 1) {
      for (var i = 0; i < arr_CheckRepeat.length - 1; i++) {
        if (arr_CheckRepeat[i] == arr_CheckRepeat[i + 1]) {
          this.LogRedInfoAndAlert("存在重复行");
          console.log("信息如下 code= " + (ele && ele.code) + " name = " + (ele && ele.name) + " 重复行信息 " + arr_CheckRepeat[i])
          i = arr_CheckRepeat.length;
          // self.doClose();
          return false;
        }
      }
    }
    config.rowItemData.fieldValues = [];
    arr_RowValues.forEach((ele) => {
      config.rowItemData.fieldValues.push(JSON.parse(ele));
    })
    //目前认为配置文件给的栏目都是全的
    // config.colItemData.fieldValues = [];
    // arr_ColValues.forEach((ele) => {
    //   config.colItemData.fieldValues.push(JSON.parse(ele));
    // })

    return true;
  }

  setGroupFields_Interface() {
    let groupFields = { idField: "", codeField: "", nameField: "" };
    this.table1D.gridModel.execute('Table2DEvent_SetGroupFields', { billNo: this.table1D.billNo, groupFields });
    if (this.isNoValue(groupFields.idField)
      || this.isNoValue(groupFields.codeField)
      || this.isNoValue(groupFields.nameField)
    ) {
      if (this.useTestData) {
        if (this.table1D.billNo == "st_purchaseorder" || this.table1D.billNo == "st_purinvoice") {
          this.LogRedInfo("分组信息缺失，默认为 product product_cCode product_cName ");
          groupFields.idField = "product";
          groupFields.codeField = "product_cCode";
          groupFields.nameField = "product_cName";
          this.group.hasGroup = true;
        }
        else if (this.table1D.billNo == "rm_saletarget") {
          groupFields.idField = "store";
          groupFields.codeField = "store_name";
          groupFields.nameField = "store_name";
          this.group.hasGroup = true;
        }
      }
      else {
        this.LogRedInfo("分组信息缺失， 接口返回的groupFields = " + JSON.stringify(groupFields) + " , groupFields将被置空。 ");
        groupFields.idField = "";
        groupFields.codeField = "";
        groupFields.nameField = "";
        this.group.hasGroup = false;
      }
    }
    else {
      this.group.hasGroup = true;
    }
    this.group.fields = groupFields;
    this.table1D.gridModel.t2DInfo_Bus_Set("groupFields", groupFields);
    this.table1D.gridModel.t2DInfo_Bus_Set("Table1DGridModel", this.table1D.gridModel);
  }

  getDefaultConfig() {
    let config = {};
    //行标题
    config.rowItemData = {
      fieldNames: [],
      fieldValues: [], //["0000000003", "CC02"], ["11110023", "TestApiAdd"], ["11110024", "TestApiAddX"]
      fieldHide: [],//暂不使用该属性
      fieldObjs: {}//   fieldObjs: { fieldName: [{ fieldValue: "", fieldObj: {} }, {}] }
    };
    //列标题
    config.colItemData = {
      fieldNames: [],// fieldNames: ["project_name", "requirementDate"], //币种编码 单据日期
      fieldValues: [], // fieldValues: [["CNY", "2019-08-23"], ["CNY", "2019-09-09"], ["用", "2019-08-16"], ["用", "2019-08-22"], ["用", "2019-08-28"], ["用", "2019-09-09"]]
      fieldMultiCol: [],//多层栏目显示字段//暂不使用该属性
      fieldObjs: {}
      //  格式 fieldObjs: { fieldName: [{ fieldValue: "", fieldObj: {} }, { fieldValue: "", fieldObj: {} }] }
      // 示例 {
      //   departmentName: [{
      //     fieldValue: "部门A",
      //     fieldObj: { depId:2,depCode:"001",depName:"部门A"}
      //   }, {
      //     fieldValue: "部门B",
      //     fieldObj: { ......}
      //   }],
      //     cusName: [{
      //       fieldValue: "客户A",
      //       fieldObj: { ......}
      //     }, {
      //       fieldValue: "客户B",
      //       fieldObj: { ......}
      //     }]
      // }
    };

    config.crossItemData = {
      fieldNames: [] //交叉点 数量 ["qty","price"]
    };
    config.insertRowConfig = {
      unCopyFieldNames: ["_id", "t2DRowKey", "pubts"]
    }
    let items = this.billConfig.items;
    items && items.forEach((item) => {
      // groupType 0 行标题 1 列标题 2 交叉点
      if (item.groupType == "0") {
        config.rowItemData.fieldNames.push(item.fieldname);
      }
      else if (item.groupType == "1") {
        config.colItemData.fieldNames.push(item.fieldname);
        config.colItemData.fieldMultiCol.push(item.fieldname);
      }
      else if (item.groupType == undefined || item.groupType == "2") {
        config.crossItemData.fieldNames.push(item.fieldname);
      }
    })
    return config;
  }

  //设置当前选择物料的行列标题，交叉点的字段
  getConfig_Interface(ele) {
    let id = ele && ele.id;
    let code = ele && ele.code;
    // let name = ele && ele.name;
    let config = this.getDefaultConfig();
    this.LogInfo("调用获取配置文件接口前" + JSON.stringify(config));
    this.table1D.gridModel.execute('Table2DEvent_SetConfig', { billNo: this.table1D.billNo, id: id, code: code, config });
    this.LogInfo("调用获取配置文件接口后" + JSON.stringify(config));
    if (this.useTestData && this.table1D.billNo == "rm_saletarget") {
      _.remove(config.rowItemData.fieldNames, function (o) { return o == "store_name" });
      this.LogInfo("调用获取配置文件接口-整理后" + JSON.stringify(config));
    }
    // if (this.useTestData) {
    //   if (config.rowItemData.fieldNames.length == 0) {
    //     config.rowItemData.fieldNames.push("bodyItem!define5");
    //     this.LogRedInfo("配置文件中没有行标题，使用bodyItem!define5");
    //   }
    //   if (config.colItemData.fieldNames.length == 0) {
    //     config.colItemData.fieldNames.push("bodyItem!define6");
    //     config.colItemData.fieldMultiCol.push("bodyItem!define6");
    //     config.colItemData.fieldValues.push(["37"]);
    //     config.colItemData.fieldValues.push(["38"]);
    //     config.colItemData.fieldValues.push(["39"]);
    //     this.LogRedInfo("！！！配置文件中没有列标题，使用bodyItem!define6");
    //   }
    //   if (this.table1D.billNo == "pc_product") {
    //     // config.colItemData.fieldObjs = {
    //     //   freeType: [{
    //     //     fieldValue: "存货",
    //     //     fieldObj: {
    //     //       enumKey: 0
    //     //     }
    //     //   }, {
    //     //     fieldValue: "制造",
    //     //     fieldObj: {
    //     //       enumKey: 1
    //     //     }
    //     //   }]
    //     // }
    //   }
    // }
    return config;
  }

  formatConfigData(config) {
    let colItemData = config.colItemData;
    let gridModel = this.table1D.gridModel;
    let formatColsInfo = {};
    if (colItemData.fieldNames.length > 0 && colItemData.fieldValues.length > 0) {
      colItemData.fieldValues.forEach((titleValueArr) => {
        if (_.isEmpty(titleValueArr) == false) {
          titleValueArr.forEach((titleValue, index) => {
            let col = gridModel.getColumn(colItemData.fieldNames[index]);
            if (titleValue && col && col.cFormatData && col.cControlType == "DatePicker") {
              formatColsInfo[colItemData.fieldNames[index]] = col.cFormatData;
              titleValueArr[index] = format.dateFormat(new Date(titleValue), col.cFormatData)
            }
          })
        }
      })
    }
    this.formatColsInfo = formatColsInfo;
  }
  setConfigData_Interface(ele, config) {
    //调用业务组接口，让业务组继续预置行标题和列标题的值
    let id = ele && ele.id;
    let code = ele && ele.code;
    // let name = ele && ele.name;
    this.table1D.gridModel.execute('Table2DEvent_SetConfigData', { billNo: this.table1D.billNo, id: id, code: code, config });
    this.formatConfigData(config);
    // this.LogInfo(" 业务组处理完的配置文件 config = " + JSON.stringify(config));
  }

  //检查 行列标题，交叉点的字段 是否存在与当前栏目中。根据源gridModel的columns，去除无效的配置文件中的栏目
  checkFieldsInColumn(ele, config) {
    let gridModel = this.table1D.gridModel;
    let configBak = _.cloneDeep(config);

    let hasErrorFieldName = false;
    let bOK = true;

    let rowItemData = config && config.rowItemData;
    if (_.isEmpty(rowItemData) == false) {
      let fieldNames = rowItemData.fieldNames;
      let fieldValues = rowItemData.fieldValues;
      let length = fieldNames.length;
      if (length) {
        for (let i = length - 1; i >= 0; i--) {
          let fieldName = fieldNames[i];
          if (gridModel.hasColumn(fieldName) == false) {
            hasErrorFieldName = true;
            fieldNames.splice(i, 1);
            fieldValues.forEach((arr) => {
              arr.splice(i, 1);
            })
          }
        }
        if (fieldNames.length == 0)
          rowItemData.fieldValues = [];
      }
    }
    let colItemData = config && config.colItemData;
    if (_.isEmpty(colItemData) == false) {
      let fieldNames = colItemData.fieldNames;
      let fieldValues = colItemData.fieldValues;
      let length = fieldNames.length;
      if (length) {
        for (let i = length - 1; i >= 0; i--) {
          let fieldName = fieldNames[i];
          if (gridModel.hasColumn(fieldName) == false) {
            hasErrorFieldName = true;
            fieldNames.splice(i, 1);
            fieldValues.forEach((arr) => {
              arr.splice(i, 1);
            })
          }
        }
        if (fieldNames.length == 0)
          colItemData.fieldValues = [];
      }
    }

    if (_.isEmpty(config.crossItemData.fieldNames) == false) {
      let length = config.crossItemData.fieldNames.length;
      if (length) {
        for (let i = length - 1; i >= 0; i--) {
          if (gridModel.hasColumn(config.crossItemData.fieldNames[i]) == false) {
            hasErrorFieldName = true;
            config.crossItemData.fieldNames.splice(i, 1);
          }
        }
      }
    }
    // if (_.isEmpty(rowItemData) || _.isEmpty(rowItemData.fieldNames)) {
    //   this.LogRedInfoAndAlert("配置文件中行标题为空或者配置字段不存在于源表栏目中，请检查。");
    //   hasErrorFieldName = true;
    //   bOK = false;
    // }
    // else if (_.isEmpty(config.crossItemData.fieldNames)) {
    //   this.LogRedInfoAndAlert("配置文件中交叉点为空或者配置字段不存在于源表栏目中，请检查。");
    //   hasErrorFieldName = true;
    //   bOK = false;
    // }
    if (hasErrorFieldName) {
      this.LogRedInfo("配置信息中字段验证失败。包含栏目中不存在的字段 转换前 " + JSON.stringify(configBak));
      this.LogRedInfo("配置信息中字段验证失败。包含栏目中不存在的字段 转换后 " + JSON.stringify(config));
      bOK = false;
    }
    else {
      this.LogInfo("配置信息中栏目验证OK ", true);
    }
    return bOK;
  }

  render() {
    let self = this;
    let GroupFieldsRender = this.getGroupFieldsRender()
    let tableRender = this.getTableRender();
    this.clearGroupReferModelValue();
    this.LogInfo_All();
    if (this.bInitHasErr == true) {
      return null;
    }
    else {
      let className = "Table2D_Outer ";//+ (self.props.bMax == true ? "Table2D_MaxSize" : "Table2D_NormalSize")
      let style = { display: (self.state.visible == true ? '' : 'none') };
      return <div style={style} className={className}>
        <div className="Table2D_Btn">
          <Button style={{ display: "none" }} onClick={e => this.addGroup()}>增加物料</Button>
          <Button style={{ display: "none" }} onClick={e => this.delGroup()}>删除物料</Button>
          <Button style={{ display: (cb.isTest_Table2D_NeedAddRow ? "" : "none") }} onClick={e => this.addRow()}>增行</Button>
          <Button style={{ display: "none" }} onClick={e => this.delRow()}>删行</Button>
          {/* {referRender} */}
        </div>
        <div className="Table2D_Inner">
          <div className="Table2D_Left" style={{ display: self.group.hasGroup ? "" : "none" }}>
            <div className="Table2D_GroupRefer">
              <Refer model={self.table1D.groupReferModel} />
            </div>
            <div className="Table2D_GroupList">
              {GroupFieldsRender}
            </div>
          </div>
          <div className="Table2D_Right">
            {tableRender}
          </div>
        </div>
      </div>;
    }
  }

  isNoValue(value) {
    if (Object.prototype.toString.call(value)==="[object Object]") {
      if (_.isEmpty(value)) {
        return true;
      }
    } else if (cb.utils.isEmpty(value)) {
      return true;
    }
    return false;
  }
  getNumPoint(field, defaultValue) {
    let fieldModel = this.getTable1DFieldModelInEditRowModel(field);
    let iNumPoint = fieldModel && fieldModel.get("iNumPoint");
    return iNumPoint || defaultValue;
  }

  doProxy(url, method, params, callback, noUniform) {
    const config = { url: url, method: method, params: params };
    if (noUniform) {
      config.options = { uniform: false };
    }
    proxy(config)
      .then(json => {
        callback(json);
      });
  }

  getBillConfig_Interface() {
    let self = this;
    let url = "/report/getTotalSetting";
    let callback = (json) => {
      if (json.code === 200) {
        self.billConfig.billConfigIsLoad = true;
        if (json.data && json.data.items && json.data.items.length > 0) {
          self.billConfig.items = json.data.items;
        }
        if (self.isConfigOKAndDataLoaded() == true) {
          // self.setTable1DFocusedInfo();
          // self.setGroupDataAndChooseGroup();
          self.chooseGroup();
        }
      }
      else {
        self.LogRedInfoAndAlert("调用获取单据配置的服务返回错误。url = " + url + " json.message = " + json.message);
      }
    }
    self.doProxy(url, 'GET', { billnum: self.table1D.billNo, isOnlySelected: true }, callback);
  }

  //FLH 2D OK  增行怎么处理
  calcTotalSum(bReCalc, fieldName) {
    let self = this;
    if (self.hide2DSum != true) {
      let self = this;
      // let preTotalSum = this.totalSum;
      let totalSum = this.totalSum;
      if (bReCalc) {
        totalSum = {};
      }
      let rows = this.table1D.gridModel.getRows();
      let rows2 = this.table2D.gridModel.getRows();
      let columns = {};
      if (_.isEmpty(totalSum) == false && fieldName) {
        columns[fieldName] = this.table2D.gridModel.getColumn(fieldName);
      }
      else {
        columns = this.table2D.columns;
      }
      Object.values(columns).forEach((col) => {
        if (col.t2DColType == "measureItem" && col.bNeedSum == true) {
          totalSum[col.fieldName] = self.getSumData(rows, col)
        }
        if (col.t2DColType == "crossItem" && col.bNeedSum == true) {
          totalSum[col.fieldName] = self.getSumData(rows2, col)
        }
      })
      // if (bReCalc == true || _.isEqual(preTotalSum, totalSum) == false) {
      this.totalSum = totalSum;
      this.table2D.gridModel.setCache('table2DSum', [totalSum]);
      this.table2D.gridModel.doPropertyChange('setSum', [totalSum]);
      // }
    }
  }

  calculate_Add(value1, value2, numPoint) {
    let result;
    if (numPoint === undefined)
      numPoint = 10;
    if (isNaN(value1) || value1 === "") {
      return this.calculate_Add(0, value2, numPoint);
    }
    else if (isNaN(value2) || value2 === "") {
      return this.calculate_Add(value1, 0, numPoint);
    }
    else {
      result = (Number(value1) + Number(value2)).toFixed(numPoint);
    }
    return result;
  }

  calcRowCrossItemSum(bReCalc, rowIndex, data) {
    // col.t2DSumField = field;
    let self = this;
    if (self.hide2DSum != true) {
      let columns = self.table2D.gridModel.getColumns();
      let updateObj = {};
      let mappingObj = {};
      let adjustField1 = "NoThisField";
      let adjustField2 = "";
      let adjustNumPoint = 0;
      if (data) {
        adjustField1 = data.cellName;
      }
      Object.values(columns).forEach((col) => {
        if (col.t2DColType == "crossItemSum") {
          updateObj[col.fieldName] = 0;
          mappingObj[col.t2DSumField] = col.fieldName;
        }
        if (col.t2DColType == "crossItem" && col.fieldName == adjustField1) {
          adjustField2 = col.t2DInfo_MultiCol.originField;
          adjustNumPoint = col.iNumPoint;
        }
      })
      // if (bReCalc) {
      let rows = self.table2D.gridModel.getRows();
      rows.forEach((row, index) => {
        let curUpdateObj = _.cloneDeep(updateObj);
        Object.values(columns).forEach((col) => {
          if (col.t2DColType == "crossItem") {
            let originField = col.t2DInfo_MultiCol.originField;
            let updateField = mappingObj[originField];
            curUpdateObj[updateField] = self.calculate_Add(curUpdateObj[updateField], row[col.fieldName], col.iNumPoint);
          }
        })
        if (adjustField2 && index == data.rowIndex) {
          let updateField = mappingObj[adjustField2];
          //目前只有因为录入交叉点值新增行才会下面代码，所以只处理data.value,不处理 data.oldValue
          curUpdateObj[updateField] = self.calculate_Add(curUpdateObj[updateField], data.value, adjustNumPoint);
        }
        self.table2D.gridModel.updateRow(index, curUpdateObj);
      })

    }
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/table2D.jsx